import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Dimension: { input: any; output: any; }
  HexColor: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Quality: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename?: 'Asset';
  contentType?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  transform?: InputMaybe<ImageTransformOptions>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not?: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  height_not?: InputMaybe<Scalars['Int']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_gt?: InputMaybe<Scalars['Int']['input']>;
  size_gte?: InputMaybe<Scalars['Int']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_lt?: InputMaybe<Scalars['Int']['input']>;
  size_lte?: InputMaybe<Scalars['Int']['input']>;
  size_not?: InputMaybe<Scalars['Int']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  width?: InputMaybe<Scalars['Int']['input']>;
  width_exists?: InputMaybe<Scalars['Boolean']['input']>;
  width_gt?: InputMaybe<Scalars['Int']['input']>;
  width_gte?: InputMaybe<Scalars['Int']['input']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_lt?: InputMaybe<Scalars['Int']['input']>;
  width_lte?: InputMaybe<Scalars['Int']['input']>;
  width_not?: InputMaybe<Scalars['Int']['input']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  copertinaCollection?: Maybe<CopertinaCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type AssetLinkingCollectionsCopertinaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  concepts: Array<Maybe<TaxonomyConcept>>;
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataConceptsFilter = {
  descendants?: InputMaybe<ContentfulMetadataConceptsDescendantsFilter>;
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataFilter = {
  concepts?: InputMaybe<ContentfulMetadataConceptsFilter>;
  concepts_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/copertina) */
export type Copertina = Entry & _Node & {
  __typename?: 'Copertina';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  copertina?: Maybe<Asset>;
  linkedFrom?: Maybe<CopertinaLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/copertina) */
export type CopertinaCopertinaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/copertina) */
export type CopertinaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/copertina) */
export type CopertinaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type CopertinaCollection = {
  __typename?: 'CopertinaCollection';
  items: Array<Maybe<Copertina>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CopertinaFilter = {
  AND?: InputMaybe<Array<InputMaybe<CopertinaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CopertinaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copertina_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CopertinaLinkingCollections = {
  __typename?: 'CopertinaLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type CopertinaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CopertinaOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/descriptiveBlock) */
export type DescriptiveBlock = Entry & _Node & {
  __typename?: 'DescriptiveBlock';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<DescriptiveBlockDescription>;
  linkedFrom?: Maybe<DescriptiveBlockLinkingCollections>;
  secondDescription?: Maybe<DescriptiveBlockSecondDescription>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/descriptiveBlock) */
export type DescriptiveBlockDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/descriptiveBlock) */
export type DescriptiveBlockLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/descriptiveBlock) */
export type DescriptiveBlockSecondDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/descriptiveBlock) */
export type DescriptiveBlockTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type DescriptiveBlockCollection = {
  __typename?: 'DescriptiveBlockCollection';
  items: Array<Maybe<DescriptiveBlock>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DescriptiveBlockDescription = {
  __typename?: 'DescriptiveBlockDescription';
  json: Scalars['JSON']['output'];
  links: DescriptiveBlockDescriptionLinks;
};

export type DescriptiveBlockDescriptionAssets = {
  __typename?: 'DescriptiveBlockDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type DescriptiveBlockDescriptionEntries = {
  __typename?: 'DescriptiveBlockDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type DescriptiveBlockDescriptionLinks = {
  __typename?: 'DescriptiveBlockDescriptionLinks';
  assets: DescriptiveBlockDescriptionAssets;
  entries: DescriptiveBlockDescriptionEntries;
  resources: DescriptiveBlockDescriptionResources;
};

export type DescriptiveBlockDescriptionResources = {
  __typename?: 'DescriptiveBlockDescriptionResources';
  block: Array<DescriptiveBlockDescriptionResourcesBlock>;
  hyperlink: Array<DescriptiveBlockDescriptionResourcesHyperlink>;
  inline: Array<DescriptiveBlockDescriptionResourcesInline>;
};

export type DescriptiveBlockDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'DescriptiveBlockDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type DescriptiveBlockDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'DescriptiveBlockDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type DescriptiveBlockDescriptionResourcesInline = ResourceLink & {
  __typename?: 'DescriptiveBlockDescriptionResourcesInline';
  sys: ResourceSys;
};

export type DescriptiveBlockFilter = {
  AND?: InputMaybe<Array<InputMaybe<DescriptiveBlockFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DescriptiveBlockFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  secondDescription_contains?: InputMaybe<Scalars['String']['input']>;
  secondDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  secondDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DescriptiveBlockLinkingCollections = {
  __typename?: 'DescriptiveBlockLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type DescriptiveBlockLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum DescriptiveBlockOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type DescriptiveBlockSecondDescription = {
  __typename?: 'DescriptiveBlockSecondDescription';
  json: Scalars['JSON']['output'];
  links: DescriptiveBlockSecondDescriptionLinks;
};

export type DescriptiveBlockSecondDescriptionAssets = {
  __typename?: 'DescriptiveBlockSecondDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type DescriptiveBlockSecondDescriptionEntries = {
  __typename?: 'DescriptiveBlockSecondDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type DescriptiveBlockSecondDescriptionLinks = {
  __typename?: 'DescriptiveBlockSecondDescriptionLinks';
  assets: DescriptiveBlockSecondDescriptionAssets;
  entries: DescriptiveBlockSecondDescriptionEntries;
  resources: DescriptiveBlockSecondDescriptionResources;
};

export type DescriptiveBlockSecondDescriptionResources = {
  __typename?: 'DescriptiveBlockSecondDescriptionResources';
  block: Array<DescriptiveBlockSecondDescriptionResourcesBlock>;
  hyperlink: Array<DescriptiveBlockSecondDescriptionResourcesHyperlink>;
  inline: Array<DescriptiveBlockSecondDescriptionResourcesInline>;
};

export type DescriptiveBlockSecondDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'DescriptiveBlockSecondDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type DescriptiveBlockSecondDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'DescriptiveBlockSecondDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type DescriptiveBlockSecondDescriptionResourcesInline = ResourceLink & {
  __typename?: 'DescriptiveBlockSecondDescriptionResourcesInline';
  sys: ResourceSys;
};

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/fisco) */
export type Fisco = Entry & _Node & {
  __typename?: 'Fisco';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  descrizione?: Maybe<FiscoDescrizione>;
  detrazione?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<FiscoLinkingCollections>;
  sys: Sys;
  titolo?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/fisco) */
export type FiscoDescrizioneArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/fisco) */
export type FiscoDetrazioneArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/fisco) */
export type FiscoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/s2cf19z7tuq9/content_types/fisco) */
export type FiscoTitoloArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type FiscoCollection = {
  __typename?: 'FiscoCollection';
  items: Array<Maybe<Fisco>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FiscoDescrizione = {
  __typename?: 'FiscoDescrizione';
  json: Scalars['JSON']['output'];
  links: FiscoDescrizioneLinks;
};

export type FiscoDescrizioneAssets = {
  __typename?: 'FiscoDescrizioneAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type FiscoDescrizioneEntries = {
  __typename?: 'FiscoDescrizioneEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type FiscoDescrizioneLinks = {
  __typename?: 'FiscoDescrizioneLinks';
  assets: FiscoDescrizioneAssets;
  entries: FiscoDescrizioneEntries;
  resources: FiscoDescrizioneResources;
};

export type FiscoDescrizioneResources = {
  __typename?: 'FiscoDescrizioneResources';
  block: Array<FiscoDescrizioneResourcesBlock>;
  hyperlink: Array<FiscoDescrizioneResourcesHyperlink>;
  inline: Array<FiscoDescrizioneResourcesInline>;
};

export type FiscoDescrizioneResourcesBlock = ResourceLink & {
  __typename?: 'FiscoDescrizioneResourcesBlock';
  sys: ResourceSys;
};

export type FiscoDescrizioneResourcesHyperlink = ResourceLink & {
  __typename?: 'FiscoDescrizioneResourcesHyperlink';
  sys: ResourceSys;
};

export type FiscoDescrizioneResourcesInline = ResourceLink & {
  __typename?: 'FiscoDescrizioneResourcesInline';
  sys: ResourceSys;
};

export type FiscoFilter = {
  AND?: InputMaybe<Array<InputMaybe<FiscoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FiscoFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  descrizione_contains?: InputMaybe<Scalars['String']['input']>;
  descrizione_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descrizione_not_contains?: InputMaybe<Scalars['String']['input']>;
  detrazione?: InputMaybe<Scalars['String']['input']>;
  detrazione_contains?: InputMaybe<Scalars['String']['input']>;
  detrazione_exists?: InputMaybe<Scalars['Boolean']['input']>;
  detrazione_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  detrazione_not?: InputMaybe<Scalars['String']['input']>;
  detrazione_not_contains?: InputMaybe<Scalars['String']['input']>;
  detrazione_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  titolo?: InputMaybe<Scalars['String']['input']>;
  titolo_contains?: InputMaybe<Scalars['String']['input']>;
  titolo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titolo_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titolo_not?: InputMaybe<Scalars['String']['input']>;
  titolo_not_contains?: InputMaybe<Scalars['String']['input']>;
  titolo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FiscoLinkingCollections = {
  __typename?: 'FiscoLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type FiscoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum FiscoOrder {
  DetrazioneAsc = 'detrazione_ASC',
  DetrazioneDesc = 'detrazione_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ImageFormat {
  /** AVIF image format. */
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']['input']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']['input']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']['input']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']['input']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']['input']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LeadInput = {
  budget?: InputMaybe<Scalars['String']['input']>;
  cellulare: Scalars['String']['input'];
  cf?: InputMaybe<Scalars['String']['input']>;
  cognome?: InputMaybe<Scalars['String']['input']>;
  datacontatto: Scalars['String']['input'];
  email: Scalars['String']['input'];
  nome?: InputMaybe<Scalars['String']['input']>;
  nomecliente?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  piva?: InputMaybe<Scalars['String']['input']>;
  pot: Scalars['String']['input'];
  provincia: Scalars['String']['input'];
  regione: Scalars['String']['input'];
  tipo_persona: Scalars['String']['input'];
};

export type LeadOutput = {
  __typename?: 'LeadOutput';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Location = {
  __typename?: 'Location';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type MailInput = {
  content: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  vat?: InputMaybe<Scalars['String']['input']>;
};

export type ResourceLink = {
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename?: 'ResourceSys';
  linkType: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

export type Review = {
  __typename?: 'Review';
  address?: Maybe<Scalars['String']['output']>;
  categories: Array<Maybe<Scalars['String']['output']>>;
  categoryName: Scalars['String']['output'];
  cid: Scalars['String']['output'];
  fid: Scalars['String']['output'];
  isAdvertisement: Scalars['Boolean']['output'];
  isLocalGuide: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  likesCount: Scalars['Int']['output'];
  location: Location;
  name: Scalars['String']['output'];
  originalLanguage: Scalars['String']['output'];
  permanentlyClosed: Scalars['Boolean']['output'];
  placeId: Scalars['String']['output'];
  price?: Maybe<Scalars['String']['output']>;
  publishAt: Scalars['String']['output'];
  publishedAtDate: Scalars['String']['output'];
  rating?: Maybe<Scalars['Float']['output']>;
  responseFromOwnerDate?: Maybe<Scalars['String']['output']>;
  responseFromOwnerText?: Maybe<Scalars['String']['output']>;
  reviewContext?: Maybe<Scalars['JSON']['output']>;
  reviewDetailedRating?: Maybe<Scalars['JSON']['output']>;
  reviewId: Scalars['String']['output'];
  reviewImageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reviewOrigin: Scalars['String']['output'];
  reviewUrl: Scalars['String']['output'];
  reviewerId: Scalars['String']['output'];
  reviewerNumberOfReviews: Scalars['Int']['output'];
  reviewerPhotoUrl: Scalars['String']['output'];
  reviewerUrl: Scalars['String']['output'];
  reviewsCount: Scalars['Int']['output'];
  scrapedAt: Scalars['String']['output'];
  searchString: Scalars['String']['output'];
  stars: Scalars['Int']['output'];
  temporarilyClosed: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  textTranslated: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalScore: Scalars['Float']['output'];
  translatedLanguage: Scalars['String']['output'];
  url: Scalars['String']['output'];
  visitedIn?: Maybe<Scalars['String']['output']>;
};

export type SampleInput = {
  email: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SampleOutput = {
  __typename?: 'SampleOutput';
  id: Scalars['String']['output'];
};

export type SampleOutputMail = {
  __typename?: 'SampleOutputMail';
  messageId: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String']['output'];
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** The locale that was requested. */
  locale?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedVersion?: Maybe<Scalars['Int']['output']>;
  spaceId: Scalars['String']['output'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
  __typename?: 'TaxonomyConcept';
  id?: Maybe<Scalars['String']['output']>;
};

export type _Node = {
  _id: Scalars['ID']['output'];
};

/** columns and relationships of "admin_only" */
export type Admin_Only = {
  __typename?: 'admin_only';
  id: Scalars['Int']['output'];
};

/** aggregated selection of "admin_only" */
export type Admin_Only_Aggregate = {
  __typename?: 'admin_only_aggregate';
  aggregate?: Maybe<Admin_Only_Aggregate_Fields>;
  nodes: Array<Admin_Only>;
};

/** aggregate fields of "admin_only" */
export type Admin_Only_Aggregate_Fields = {
  __typename?: 'admin_only_aggregate_fields';
  avg?: Maybe<Admin_Only_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Admin_Only_Max_Fields>;
  min?: Maybe<Admin_Only_Min_Fields>;
  stddev?: Maybe<Admin_Only_Stddev_Fields>;
  stddev_pop?: Maybe<Admin_Only_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Admin_Only_Stddev_Samp_Fields>;
  sum?: Maybe<Admin_Only_Sum_Fields>;
  var_pop?: Maybe<Admin_Only_Var_Pop_Fields>;
  var_samp?: Maybe<Admin_Only_Var_Samp_Fields>;
  variance?: Maybe<Admin_Only_Variance_Fields>;
};


/** aggregate fields of "admin_only" */
export type Admin_Only_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_Only_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Admin_Only_Avg_Fields = {
  __typename?: 'admin_only_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "admin_only". All fields are combined with a logical 'AND'. */
export type Admin_Only_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Only_Bool_Exp>>;
  _not?: InputMaybe<Admin_Only_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_Only_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin_only" */
export enum Admin_Only_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdminOnlyPkey = 'admin_only_pkey'
}

/** input type for incrementing numeric columns in table "admin_only" */
export type Admin_Only_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "admin_only" */
export type Admin_Only_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Admin_Only_Max_Fields = {
  __typename?: 'admin_only_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Admin_Only_Min_Fields = {
  __typename?: 'admin_only_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "admin_only" */
export type Admin_Only_Mutation_Response = {
  __typename?: 'admin_only_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin_Only>;
};

/** on_conflict condition type for table "admin_only" */
export type Admin_Only_On_Conflict = {
  constraint: Admin_Only_Constraint;
  update_columns?: Array<Admin_Only_Update_Column>;
  where?: InputMaybe<Admin_Only_Bool_Exp>;
};

/** Ordering options when selecting data from "admin_only". */
export type Admin_Only_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: admin_only */
export type Admin_Only_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "admin_only" */
export enum Admin_Only_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "admin_only" */
export type Admin_Only_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Admin_Only_Stddev_Fields = {
  __typename?: 'admin_only_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Admin_Only_Stddev_Pop_Fields = {
  __typename?: 'admin_only_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Admin_Only_Stddev_Samp_Fields = {
  __typename?: 'admin_only_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "admin_only" */
export type Admin_Only_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Only_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_Only_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Admin_Only_Sum_Fields = {
  __typename?: 'admin_only_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "admin_only" */
export enum Admin_Only_Update_Column {
  /** column name */
  Id = 'id'
}

export type Admin_Only_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Admin_Only_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_Only_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_Only_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Admin_Only_Var_Pop_Fields = {
  __typename?: 'admin_only_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Admin_Only_Var_Samp_Fields = {
  __typename?: 'admin_only_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Admin_Only_Variance_Fields = {
  __typename?: 'admin_only_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "brands" */
export type Brands = {
  __typename?: 'brands';
  /** An array relationship */
  models: Array<Models>;
  /** An aggregate relationship */
  models_aggregate: Models_Aggregate;
  name: Scalars['String']['output'];
};


/** columns and relationships of "brands" */
export type BrandsModelsArgs = {
  distinct_on?: InputMaybe<Array<Models_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Models_Order_By>>;
  where?: InputMaybe<Models_Bool_Exp>;
};


/** columns and relationships of "brands" */
export type BrandsModels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Models_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Models_Order_By>>;
  where?: InputMaybe<Models_Bool_Exp>;
};

/** aggregated selection of "brands" */
export type Brands_Aggregate = {
  __typename?: 'brands_aggregate';
  aggregate?: Maybe<Brands_Aggregate_Fields>;
  nodes: Array<Brands>;
};

/** aggregate fields of "brands" */
export type Brands_Aggregate_Fields = {
  __typename?: 'brands_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Brands_Max_Fields>;
  min?: Maybe<Brands_Min_Fields>;
};


/** aggregate fields of "brands" */
export type Brands_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brands_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "brands". All fields are combined with a logical 'AND'. */
export type Brands_Bool_Exp = {
  _and?: InputMaybe<Array<Brands_Bool_Exp>>;
  _not?: InputMaybe<Brands_Bool_Exp>;
  _or?: InputMaybe<Array<Brands_Bool_Exp>>;
  models?: InputMaybe<Models_Bool_Exp>;
  models_aggregate?: InputMaybe<Models_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "brands" */
export enum Brands_Constraint {
  /** unique or primary key constraint on columns "name" */
  BrandsPkey = 'brands_pkey'
}

/** input type for inserting data into table "brands" */
export type Brands_Insert_Input = {
  models?: InputMaybe<Models_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Brands_Max_Fields = {
  __typename?: 'brands_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Brands_Min_Fields = {
  __typename?: 'brands_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "brands" */
export type Brands_Mutation_Response = {
  __typename?: 'brands_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Brands>;
};

/** on_conflict condition type for table "brands" */
export type Brands_On_Conflict = {
  constraint: Brands_Constraint;
  update_columns?: Array<Brands_Update_Column>;
  where?: InputMaybe<Brands_Bool_Exp>;
};

/** Ordering options when selecting data from "brands". */
export type Brands_Order_By = {
  models_aggregate?: InputMaybe<Models_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: brands */
export type Brands_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "brands" */
export enum Brands_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "brands" */
export type Brands_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "brands" */
export type Brands_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brands_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brands_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "brands" */
export enum Brands_Update_Column {
  /** column name */
  Name = 'name'
}

export type Brands_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brands_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brands_Bool_Exp;
};

/** columns and relationships of "storage.buckets" */
export type Buckets = {
  __typename?: 'buckets';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  downloadExpiration: Scalars['Int']['output'];
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  id: Scalars['String']['output'];
  maxUploadFileSize: Scalars['Int']['output'];
  minUploadFileSize: Scalars['Int']['output'];
  presignedUrlsEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "storage.buckets" */
export type BucketsFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "storage.buckets" */
export type BucketsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** aggregated selection of "storage.buckets" */
export type Buckets_Aggregate = {
  __typename?: 'buckets_aggregate';
  aggregate?: Maybe<Buckets_Aggregate_Fields>;
  nodes: Array<Buckets>;
};

/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_Fields = {
  __typename?: 'buckets_aggregate_fields';
  avg?: Maybe<Buckets_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Buckets_Max_Fields>;
  min?: Maybe<Buckets_Min_Fields>;
  stddev?: Maybe<Buckets_Stddev_Fields>;
  stddev_pop?: Maybe<Buckets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Buckets_Stddev_Samp_Fields>;
  sum?: Maybe<Buckets_Sum_Fields>;
  var_pop?: Maybe<Buckets_Var_Pop_Fields>;
  var_samp?: Maybe<Buckets_Var_Samp_Fields>;
  variance?: Maybe<Buckets_Variance_Fields>;
};


/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buckets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Buckets_Avg_Fields = {
  __typename?: 'buckets_avg_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type Buckets_Bool_Exp = {
  _and?: InputMaybe<Array<Buckets_Bool_Exp>>;
  _not?: InputMaybe<Buckets_Bool_Exp>;
  _or?: InputMaybe<Array<Buckets_Bool_Exp>>;
  cacheControl?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  downloadExpiration?: InputMaybe<Int_Comparison_Exp>;
  files?: InputMaybe<Files_Bool_Exp>;
  files_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  maxUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  minUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  presignedUrlsEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.buckets" */
export enum Buckets_Constraint {
  /** unique or primary key constraint on columns "id" */
  BucketsPkey = 'buckets_pkey'
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type Buckets_Inc_Input = {
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.buckets" */
export type Buckets_Insert_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Buckets_Max_Fields = {
  __typename?: 'buckets_max_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Buckets_Min_Fields = {
  __typename?: 'buckets_min_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "storage.buckets" */
export type Buckets_Mutation_Response = {
  __typename?: 'buckets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buckets>;
};

/** input type for inserting object relation for remote table "storage.buckets" */
export type Buckets_Obj_Rel_Insert_Input = {
  data: Buckets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};

/** on_conflict condition type for table "storage.buckets" */
export type Buckets_On_Conflict = {
  constraint: Buckets_Constraint;
  update_columns?: Array<Buckets_Update_Column>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.buckets". */
export type Buckets_Order_By = {
  cacheControl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  downloadExpiration?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  maxUploadFileSize?: InputMaybe<Order_By>;
  minUploadFileSize?: InputMaybe<Order_By>;
  presignedUrlsEnabled?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.buckets */
export type Buckets_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "storage.buckets" */
export enum Buckets_Select_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "storage.buckets" */
export type Buckets_Set_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Buckets_Stddev_Fields = {
  __typename?: 'buckets_stddev_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Buckets_Stddev_Pop_Fields = {
  __typename?: 'buckets_stddev_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Buckets_Stddev_Samp_Fields = {
  __typename?: 'buckets_stddev_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "buckets" */
export type Buckets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buckets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buckets_Stream_Cursor_Value_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Buckets_Sum_Fields = {
  __typename?: 'buckets_sum_fields';
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "storage.buckets" */
export enum Buckets_Update_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Buckets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Buckets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buckets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Buckets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Buckets_Var_Pop_Fields = {
  __typename?: 'buckets_var_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Buckets_Var_Samp_Fields = {
  __typename?: 'buckets_var_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Buckets_Variance_Fields = {
  __typename?: 'buckets_variance_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "storage.files" */
export type Files = {
  __typename?: 'files';
  /** An object relationship */
  bucket: Buckets;
  bucketId: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "storage.files" */
export type FilesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate';
  aggregate?: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

export type Files_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Files_Aggregate_Bool_Exp_Count>;
};

export type Files_Aggregate_Bool_Exp_Bool_And = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storage.files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields';
  avg?: Maybe<Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Files_Max_Fields>;
  min?: Maybe<Files_Min_Fields>;
  stddev?: Maybe<Files_Stddev_Fields>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields>;
  sum?: Maybe<Files_Sum_Fields>;
  var_pop?: Maybe<Files_Var_Pop_Fields>;
  var_samp?: Maybe<Files_Var_Samp_Fields>;
  variance?: Maybe<Files_Variance_Fields>;
};


/** aggregate fields of "storage.files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storage.files" */
export type Files_Aggregate_Order_By = {
  avg?: InputMaybe<Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Files_Max_Order_By>;
  min?: InputMaybe<Files_Min_Order_By>;
  stddev?: InputMaybe<Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Files_Sum_Order_By>;
  var_pop?: InputMaybe<Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Files_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Files_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "storage.files" */
export type Files_Arr_Rel_Insert_Input = {
  data: Array<Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  __typename?: 'files_avg_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "storage.files" */
export type Files_Avg_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  bucket?: InputMaybe<Buckets_Bool_Exp>;
  bucketId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  etag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isUploaded?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mimeType?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadedByUserId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Files_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Files_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Files_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "storage.files" */
export type Files_Inc_Input = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.files" */
export type Files_Insert_Input = {
  bucket?: InputMaybe<Buckets_Obj_Rel_Insert_Input>;
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "storage.files" */
export type Files_Max_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "storage.files" */
export type Files_Min_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storage.files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "storage.files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "storage.files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.files". */
export type Files_Order_By = {
  bucket?: InputMaybe<Buckets_Order_By>;
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isUploaded?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Files_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.files" */
export enum Files_Select_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** input type for updating data in table "storage.files" */
export type Files_Set_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  __typename?: 'files_stddev_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "storage.files" */
export type Files_Stddev_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  __typename?: 'files_stddev_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "storage.files" */
export type Files_Stddev_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  __typename?: 'files_stddev_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "storage.files" */
export type Files_Stddev_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  __typename?: 'files_sum_fields';
  size?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "storage.files" */
export type Files_Sum_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** update columns of table "storage.files" */
export enum Files_Update_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

export type Files_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Files_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Files_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  __typename?: 'files_var_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "storage.files" */
export type Files_Var_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  __typename?: 'files_var_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "storage.files" */
export type Files_Var_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  __typename?: 'files_variance_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "storage.files" */
export type Files_Variance_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** columns and relationships of "final_prices" */
export type Final_Prices = {
  __typename?: 'final_prices';
  courtesy_car?: Maybe<Scalars['Boolean']['output']>;
  courtesy_car_price?: Maybe<Scalars['numeric']['output']>;
  down_payment?: Maybe<Scalars['numeric']['output']>;
  final_monthly_price?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  model_id?: Maybe<Scalars['uuid']['output']>;
  monthly_payment?: Maybe<Scalars['numeric']['output']>;
  rental_distance?: Maybe<Scalars['Int']['output']>;
  rental_duration?: Maybe<Scalars['Int']['output']>;
  tyres?: Maybe<Scalars['Boolean']['output']>;
  tyres_price?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "final_prices" */
export type Final_Prices_Aggregate = {
  __typename?: 'final_prices_aggregate';
  aggregate?: Maybe<Final_Prices_Aggregate_Fields>;
  nodes: Array<Final_Prices>;
};

/** aggregate fields of "final_prices" */
export type Final_Prices_Aggregate_Fields = {
  __typename?: 'final_prices_aggregate_fields';
  avg?: Maybe<Final_Prices_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Final_Prices_Max_Fields>;
  min?: Maybe<Final_Prices_Min_Fields>;
  stddev?: Maybe<Final_Prices_Stddev_Fields>;
  stddev_pop?: Maybe<Final_Prices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Final_Prices_Stddev_Samp_Fields>;
  sum?: Maybe<Final_Prices_Sum_Fields>;
  var_pop?: Maybe<Final_Prices_Var_Pop_Fields>;
  var_samp?: Maybe<Final_Prices_Var_Samp_Fields>;
  variance?: Maybe<Final_Prices_Variance_Fields>;
};


/** aggregate fields of "final_prices" */
export type Final_Prices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Final_Prices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Final_Prices_Avg_Fields = {
  __typename?: 'final_prices_avg_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  final_monthly_price?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "final_prices". All fields are combined with a logical 'AND'. */
export type Final_Prices_Bool_Exp = {
  _and?: InputMaybe<Array<Final_Prices_Bool_Exp>>;
  _not?: InputMaybe<Final_Prices_Bool_Exp>;
  _or?: InputMaybe<Array<Final_Prices_Bool_Exp>>;
  courtesy_car?: InputMaybe<Boolean_Comparison_Exp>;
  courtesy_car_price?: InputMaybe<Numeric_Comparison_Exp>;
  down_payment?: InputMaybe<Numeric_Comparison_Exp>;
  final_monthly_price?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  model_id?: InputMaybe<Uuid_Comparison_Exp>;
  monthly_payment?: InputMaybe<Numeric_Comparison_Exp>;
  rental_distance?: InputMaybe<Int_Comparison_Exp>;
  rental_duration?: InputMaybe<Int_Comparison_Exp>;
  tyres?: InputMaybe<Boolean_Comparison_Exp>;
  tyres_price?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Final_Prices_Max_Fields = {
  __typename?: 'final_prices_max_fields';
  courtesy_car_price?: Maybe<Scalars['numeric']['output']>;
  down_payment?: Maybe<Scalars['numeric']['output']>;
  final_monthly_price?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  model_id?: Maybe<Scalars['uuid']['output']>;
  monthly_payment?: Maybe<Scalars['numeric']['output']>;
  rental_distance?: Maybe<Scalars['Int']['output']>;
  rental_duration?: Maybe<Scalars['Int']['output']>;
  tyres_price?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Final_Prices_Min_Fields = {
  __typename?: 'final_prices_min_fields';
  courtesy_car_price?: Maybe<Scalars['numeric']['output']>;
  down_payment?: Maybe<Scalars['numeric']['output']>;
  final_monthly_price?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  model_id?: Maybe<Scalars['uuid']['output']>;
  monthly_payment?: Maybe<Scalars['numeric']['output']>;
  rental_distance?: Maybe<Scalars['Int']['output']>;
  rental_duration?: Maybe<Scalars['Int']['output']>;
  tyres_price?: Maybe<Scalars['numeric']['output']>;
};

/** Ordering options when selecting data from "final_prices". */
export type Final_Prices_Order_By = {
  courtesy_car?: InputMaybe<Order_By>;
  courtesy_car_price?: InputMaybe<Order_By>;
  down_payment?: InputMaybe<Order_By>;
  final_monthly_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  monthly_payment?: InputMaybe<Order_By>;
  rental_distance?: InputMaybe<Order_By>;
  rental_duration?: InputMaybe<Order_By>;
  tyres?: InputMaybe<Order_By>;
  tyres_price?: InputMaybe<Order_By>;
};

/** select columns of table "final_prices" */
export enum Final_Prices_Select_Column {
  /** column name */
  CourtesyCar = 'courtesy_car',
  /** column name */
  CourtesyCarPrice = 'courtesy_car_price',
  /** column name */
  DownPayment = 'down_payment',
  /** column name */
  FinalMonthlyPrice = 'final_monthly_price',
  /** column name */
  Id = 'id',
  /** column name */
  ModelId = 'model_id',
  /** column name */
  MonthlyPayment = 'monthly_payment',
  /** column name */
  RentalDistance = 'rental_distance',
  /** column name */
  RentalDuration = 'rental_duration',
  /** column name */
  Tyres = 'tyres',
  /** column name */
  TyresPrice = 'tyres_price'
}

/** aggregate stddev on columns */
export type Final_Prices_Stddev_Fields = {
  __typename?: 'final_prices_stddev_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  final_monthly_price?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Final_Prices_Stddev_Pop_Fields = {
  __typename?: 'final_prices_stddev_pop_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  final_monthly_price?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Final_Prices_Stddev_Samp_Fields = {
  __typename?: 'final_prices_stddev_samp_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  final_monthly_price?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "final_prices" */
export type Final_Prices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Final_Prices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Final_Prices_Stream_Cursor_Value_Input = {
  courtesy_car?: InputMaybe<Scalars['Boolean']['input']>;
  courtesy_car_price?: InputMaybe<Scalars['numeric']['input']>;
  down_payment?: InputMaybe<Scalars['numeric']['input']>;
  final_monthly_price?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  model_id?: InputMaybe<Scalars['uuid']['input']>;
  monthly_payment?: InputMaybe<Scalars['numeric']['input']>;
  rental_distance?: InputMaybe<Scalars['Int']['input']>;
  rental_duration?: InputMaybe<Scalars['Int']['input']>;
  tyres?: InputMaybe<Scalars['Boolean']['input']>;
  tyres_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Final_Prices_Sum_Fields = {
  __typename?: 'final_prices_sum_fields';
  courtesy_car_price?: Maybe<Scalars['numeric']['output']>;
  down_payment?: Maybe<Scalars['numeric']['output']>;
  final_monthly_price?: Maybe<Scalars['numeric']['output']>;
  monthly_payment?: Maybe<Scalars['numeric']['output']>;
  rental_distance?: Maybe<Scalars['Int']['output']>;
  rental_duration?: Maybe<Scalars['Int']['output']>;
  tyres_price?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Final_Prices_Var_Pop_Fields = {
  __typename?: 'final_prices_var_pop_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  final_monthly_price?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Final_Prices_Var_Samp_Fields = {
  __typename?: 'final_prices_var_samp_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  final_monthly_price?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Final_Prices_Variance_Fields = {
  __typename?: 'final_prices_variance_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  final_monthly_price?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "models" */
export type Models = {
  __typename?: 'models';
  brand: Scalars['String']['output'];
  engine: Scalars['String']['output'];
  furgone: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  imgs?: Maybe<Array<Scalars['String']['output']>>;
  model_name: Scalars['String']['output'];
  new_driving_license: Scalars['Boolean']['output'];
  /** An array relationship */
  prices: Array<Prices>;
  /** An aggregate relationship */
  prices_aggregate: Prices_Aggregate;
  /** An object relationship */
  traction: Tractions;
  traction_type: Tractions_Enum;
};


/** columns and relationships of "models" */
export type ModelsPricesArgs = {
  distinct_on?: InputMaybe<Array<Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prices_Order_By>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};


/** columns and relationships of "models" */
export type ModelsPrices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prices_Order_By>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};

/** aggregated selection of "models" */
export type Models_Aggregate = {
  __typename?: 'models_aggregate';
  aggregate?: Maybe<Models_Aggregate_Fields>;
  nodes: Array<Models>;
};

export type Models_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Models_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Models_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Models_Aggregate_Bool_Exp_Count>;
};

export type Models_Aggregate_Bool_Exp_Bool_And = {
  arguments: Models_Select_Column_Models_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Models_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Models_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Models_Select_Column_Models_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Models_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Models_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Models_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Models_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "models" */
export type Models_Aggregate_Fields = {
  __typename?: 'models_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Models_Max_Fields>;
  min?: Maybe<Models_Min_Fields>;
};


/** aggregate fields of "models" */
export type Models_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Models_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "models" */
export type Models_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Models_Max_Order_By>;
  min?: InputMaybe<Models_Min_Order_By>;
};

/** input type for inserting array relation for remote table "models" */
export type Models_Arr_Rel_Insert_Input = {
  data: Array<Models_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Models_On_Conflict>;
};

/** Boolean expression to filter rows from the table "models". All fields are combined with a logical 'AND'. */
export type Models_Bool_Exp = {
  _and?: InputMaybe<Array<Models_Bool_Exp>>;
  _not?: InputMaybe<Models_Bool_Exp>;
  _or?: InputMaybe<Array<Models_Bool_Exp>>;
  brand?: InputMaybe<String_Comparison_Exp>;
  engine?: InputMaybe<String_Comparison_Exp>;
  furgone?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imgs?: InputMaybe<String_Array_Comparison_Exp>;
  model_name?: InputMaybe<String_Comparison_Exp>;
  new_driving_license?: InputMaybe<Boolean_Comparison_Exp>;
  prices?: InputMaybe<Prices_Bool_Exp>;
  prices_aggregate?: InputMaybe<Prices_Aggregate_Bool_Exp>;
  traction?: InputMaybe<Tractions_Bool_Exp>;
  traction_type?: InputMaybe<Tractions_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "models" */
export enum Models_Constraint {
  /** unique or primary key constraint on columns "model_name" */
  ModelsModeNameKey = 'models_mode_name_key',
  /** unique or primary key constraint on columns "id" */
  ModelsPkey = 'models_pkey'
}

/** input type for inserting data into table "models" */
export type Models_Insert_Input = {
  brand?: InputMaybe<Scalars['String']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  furgone?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imgs?: InputMaybe<Array<Scalars['String']['input']>>;
  model_name?: InputMaybe<Scalars['String']['input']>;
  new_driving_license?: InputMaybe<Scalars['Boolean']['input']>;
  prices?: InputMaybe<Prices_Arr_Rel_Insert_Input>;
  traction?: InputMaybe<Tractions_Obj_Rel_Insert_Input>;
  traction_type?: InputMaybe<Tractions_Enum>;
};

/** aggregate max on columns */
export type Models_Max_Fields = {
  __typename?: 'models_max_fields';
  brand?: Maybe<Scalars['String']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imgs?: Maybe<Array<Scalars['String']['output']>>;
  model_name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "models" */
export type Models_Max_Order_By = {
  brand?: InputMaybe<Order_By>;
  engine?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imgs?: InputMaybe<Order_By>;
  model_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Models_Min_Fields = {
  __typename?: 'models_min_fields';
  brand?: Maybe<Scalars['String']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imgs?: Maybe<Array<Scalars['String']['output']>>;
  model_name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "models" */
export type Models_Min_Order_By = {
  brand?: InputMaybe<Order_By>;
  engine?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imgs?: InputMaybe<Order_By>;
  model_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "models" */
export type Models_Mutation_Response = {
  __typename?: 'models_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Models>;
};

/** on_conflict condition type for table "models" */
export type Models_On_Conflict = {
  constraint: Models_Constraint;
  update_columns?: Array<Models_Update_Column>;
  where?: InputMaybe<Models_Bool_Exp>;
};

/** Ordering options when selecting data from "models". */
export type Models_Order_By = {
  brand?: InputMaybe<Order_By>;
  engine?: InputMaybe<Order_By>;
  furgone?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imgs?: InputMaybe<Order_By>;
  model_name?: InputMaybe<Order_By>;
  new_driving_license?: InputMaybe<Order_By>;
  prices_aggregate?: InputMaybe<Prices_Aggregate_Order_By>;
  traction?: InputMaybe<Tractions_Order_By>;
  traction_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: models */
export type Models_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "models" */
export enum Models_Select_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  Engine = 'engine',
  /** column name */
  Furgone = 'furgone',
  /** column name */
  Id = 'id',
  /** column name */
  Imgs = 'imgs',
  /** column name */
  ModelName = 'model_name',
  /** column name */
  NewDrivingLicense = 'new_driving_license',
  /** column name */
  TractionType = 'traction_type'
}

/** select "models_aggregate_bool_exp_bool_and_arguments_columns" columns of table "models" */
export enum Models_Select_Column_Models_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Furgone = 'furgone',
  /** column name */
  NewDrivingLicense = 'new_driving_license'
}

/** select "models_aggregate_bool_exp_bool_or_arguments_columns" columns of table "models" */
export enum Models_Select_Column_Models_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Furgone = 'furgone',
  /** column name */
  NewDrivingLicense = 'new_driving_license'
}

/** input type for updating data in table "models" */
export type Models_Set_Input = {
  brand?: InputMaybe<Scalars['String']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  furgone?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imgs?: InputMaybe<Array<Scalars['String']['input']>>;
  model_name?: InputMaybe<Scalars['String']['input']>;
  new_driving_license?: InputMaybe<Scalars['Boolean']['input']>;
  traction_type?: InputMaybe<Tractions_Enum>;
};

/** Streaming cursor of the table "models" */
export type Models_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Models_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Models_Stream_Cursor_Value_Input = {
  brand?: InputMaybe<Scalars['String']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  furgone?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imgs?: InputMaybe<Array<Scalars['String']['input']>>;
  model_name?: InputMaybe<Scalars['String']['input']>;
  new_driving_license?: InputMaybe<Scalars['Boolean']['input']>;
  traction_type?: InputMaybe<Tractions_Enum>;
};

/** update columns of table "models" */
export enum Models_Update_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  Engine = 'engine',
  /** column name */
  Furgone = 'furgone',
  /** column name */
  Id = 'id',
  /** column name */
  Imgs = 'imgs',
  /** column name */
  ModelName = 'model_name',
  /** column name */
  NewDrivingLicense = 'new_driving_license',
  /** column name */
  TractionType = 'traction_type'
}

export type Models_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Models_Set_Input>;
  /** filter the rows which have to be updated */
  where: Models_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  addLead?: Maybe<LeadOutput>;
  /** delete single row from the table: "storage.buckets" */
  deleteBucket?: Maybe<Buckets>;
  /** delete data from the table: "storage.buckets" */
  deleteBuckets?: Maybe<Buckets_Mutation_Response>;
  /** delete single row from the table: "storage.files" */
  deleteFile?: Maybe<Files>;
  /** delete data from the table: "storage.files" */
  deleteFiles?: Maybe<Files_Mutation_Response>;
  /** delete single row from the table: "storage.virus" */
  deleteVirus?: Maybe<Virus>;
  /** delete data from the table: "storage.virus" */
  deleteViruses?: Maybe<Virus_Mutation_Response>;
  /** delete data from the table: "admin_only" */
  delete_admin_only?: Maybe<Admin_Only_Mutation_Response>;
  /** delete single row from the table: "admin_only" */
  delete_admin_only_by_pk?: Maybe<Admin_Only>;
  /** delete data from the table: "brands" */
  delete_brands?: Maybe<Brands_Mutation_Response>;
  /** delete single row from the table: "brands" */
  delete_brands_by_pk?: Maybe<Brands>;
  /** delete data from the table: "models" */
  delete_models?: Maybe<Models_Mutation_Response>;
  /** delete single row from the table: "models" */
  delete_models_by_pk?: Maybe<Models>;
  /** delete data from the table: "prices" */
  delete_prices?: Maybe<Prices_Mutation_Response>;
  /** delete single row from the table: "prices" */
  delete_prices_by_pk?: Maybe<Prices>;
  /** delete data from the table: "rental_distance" */
  delete_rental_distance?: Maybe<Rental_Distance_Mutation_Response>;
  /** delete single row from the table: "rental_distance" */
  delete_rental_distance_by_pk?: Maybe<Rental_Distance>;
  /** delete data from the table: "rental_duration" */
  delete_rental_duration?: Maybe<Rental_Duration_Mutation_Response>;
  /** delete single row from the table: "rental_duration" */
  delete_rental_duration_by_pk?: Maybe<Rental_Duration>;
  /** delete data from the table: "tractions" */
  delete_tractions?: Maybe<Tractions_Mutation_Response>;
  /** delete single row from the table: "tractions" */
  delete_tractions_by_pk?: Maybe<Tractions>;
  /** insert a single row into the table: "storage.buckets" */
  insertBucket?: Maybe<Buckets>;
  /** insert data into the table: "storage.buckets" */
  insertBuckets?: Maybe<Buckets_Mutation_Response>;
  /** insert a single row into the table: "storage.files" */
  insertFile?: Maybe<Files>;
  /** insert data into the table: "storage.files" */
  insertFiles?: Maybe<Files_Mutation_Response>;
  /** insert a single row into the table: "storage.virus" */
  insertVirus?: Maybe<Virus>;
  /** insert data into the table: "storage.virus" */
  insertViruses?: Maybe<Virus_Mutation_Response>;
  /** insert data into the table: "admin_only" */
  insert_admin_only?: Maybe<Admin_Only_Mutation_Response>;
  /** insert a single row into the table: "admin_only" */
  insert_admin_only_one?: Maybe<Admin_Only>;
  /** insert data into the table: "brands" */
  insert_brands?: Maybe<Brands_Mutation_Response>;
  /** insert a single row into the table: "brands" */
  insert_brands_one?: Maybe<Brands>;
  /** insert data into the table: "models" */
  insert_models?: Maybe<Models_Mutation_Response>;
  /** insert a single row into the table: "models" */
  insert_models_one?: Maybe<Models>;
  /** insert data into the table: "prices" */
  insert_prices?: Maybe<Prices_Mutation_Response>;
  /** insert a single row into the table: "prices" */
  insert_prices_one?: Maybe<Prices>;
  /** insert data into the table: "rental_distance" */
  insert_rental_distance?: Maybe<Rental_Distance_Mutation_Response>;
  /** insert a single row into the table: "rental_distance" */
  insert_rental_distance_one?: Maybe<Rental_Distance>;
  /** insert data into the table: "rental_duration" */
  insert_rental_duration?: Maybe<Rental_Duration_Mutation_Response>;
  /** insert a single row into the table: "rental_duration" */
  insert_rental_duration_one?: Maybe<Rental_Duration>;
  /** insert data into the table: "tractions" */
  insert_tractions?: Maybe<Tractions_Mutation_Response>;
  /** insert a single row into the table: "tractions" */
  insert_tractions_one?: Maybe<Tractions>;
  sendContactEmail?: Maybe<SampleOutputMail>;
  subscribeNewsletter?: Maybe<SampleOutput>;
  /** update single row of the table: "storage.buckets" */
  updateBucket?: Maybe<Buckets>;
  /** update data of the table: "storage.buckets" */
  updateBuckets?: Maybe<Buckets_Mutation_Response>;
  /** update single row of the table: "storage.files" */
  updateFile?: Maybe<Files>;
  /** update data of the table: "storage.files" */
  updateFiles?: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "storage.virus" */
  updateVirus?: Maybe<Virus>;
  /** update data of the table: "storage.virus" */
  updateViruses?: Maybe<Virus_Mutation_Response>;
  /** update data of the table: "admin_only" */
  update_admin_only?: Maybe<Admin_Only_Mutation_Response>;
  /** update single row of the table: "admin_only" */
  update_admin_only_by_pk?: Maybe<Admin_Only>;
  /** update multiples rows of table: "admin_only" */
  update_admin_only_many?: Maybe<Array<Maybe<Admin_Only_Mutation_Response>>>;
  /** update data of the table: "brands" */
  update_brands?: Maybe<Brands_Mutation_Response>;
  /** update single row of the table: "brands" */
  update_brands_by_pk?: Maybe<Brands>;
  /** update multiples rows of table: "brands" */
  update_brands_many?: Maybe<Array<Maybe<Brands_Mutation_Response>>>;
  /** update multiples rows of table: "storage.buckets" */
  update_buckets_many?: Maybe<Array<Maybe<Buckets_Mutation_Response>>>;
  /** update multiples rows of table: "storage.files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "models" */
  update_models?: Maybe<Models_Mutation_Response>;
  /** update single row of the table: "models" */
  update_models_by_pk?: Maybe<Models>;
  /** update multiples rows of table: "models" */
  update_models_many?: Maybe<Array<Maybe<Models_Mutation_Response>>>;
  /** update data of the table: "prices" */
  update_prices?: Maybe<Prices_Mutation_Response>;
  /** update single row of the table: "prices" */
  update_prices_by_pk?: Maybe<Prices>;
  /** update multiples rows of table: "prices" */
  update_prices_many?: Maybe<Array<Maybe<Prices_Mutation_Response>>>;
  /** update data of the table: "rental_distance" */
  update_rental_distance?: Maybe<Rental_Distance_Mutation_Response>;
  /** update single row of the table: "rental_distance" */
  update_rental_distance_by_pk?: Maybe<Rental_Distance>;
  /** update multiples rows of table: "rental_distance" */
  update_rental_distance_many?: Maybe<Array<Maybe<Rental_Distance_Mutation_Response>>>;
  /** update data of the table: "rental_duration" */
  update_rental_duration?: Maybe<Rental_Duration_Mutation_Response>;
  /** update single row of the table: "rental_duration" */
  update_rental_duration_by_pk?: Maybe<Rental_Duration>;
  /** update multiples rows of table: "rental_duration" */
  update_rental_duration_many?: Maybe<Array<Maybe<Rental_Duration_Mutation_Response>>>;
  /** update data of the table: "tractions" */
  update_tractions?: Maybe<Tractions_Mutation_Response>;
  /** update single row of the table: "tractions" */
  update_tractions_by_pk?: Maybe<Tractions>;
  /** update multiples rows of table: "tractions" */
  update_tractions_many?: Maybe<Array<Maybe<Tractions_Mutation_Response>>>;
  /** update multiples rows of table: "storage.virus" */
  update_virus_many?: Maybe<Array<Maybe<Virus_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootAddLeadArgs = {
  arg1: LeadInput;
};


/** mutation root */
export type Mutation_RootDeleteBucketArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBucketsArgs = {
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFileArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteFilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteVirusArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteVirusesArgs = {
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin_OnlyArgs = {
  where: Admin_Only_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin_Only_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BrandsArgs = {
  where: Brands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brands_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ModelsArgs = {
  where: Models_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Models_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PricesArgs = {
  where: Prices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rental_DistanceArgs = {
  where: Rental_Distance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rental_Distance_By_PkArgs = {
  km: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rental_DurationArgs = {
  where: Rental_Duration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rental_Duration_By_PkArgs = {
  months: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TractionsArgs = {
  where: Tractions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tractions_By_PkArgs = {
  kind: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsertBucketArgs = {
  object: Buckets_Insert_Input;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketsArgs = {
  objects: Array<Buckets_Insert_Input>;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFileArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusArgs = {
  object: Virus_Insert_Input;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusesArgs = {
  objects: Array<Virus_Insert_Input>;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_OnlyArgs = {
  objects: Array<Admin_Only_Insert_Input>;
  on_conflict?: InputMaybe<Admin_Only_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_Only_OneArgs = {
  object: Admin_Only_Insert_Input;
  on_conflict?: InputMaybe<Admin_Only_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BrandsArgs = {
  objects: Array<Brands_Insert_Input>;
  on_conflict?: InputMaybe<Brands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brands_OneArgs = {
  object: Brands_Insert_Input;
  on_conflict?: InputMaybe<Brands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ModelsArgs = {
  objects: Array<Models_Insert_Input>;
  on_conflict?: InputMaybe<Models_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Models_OneArgs = {
  object: Models_Insert_Input;
  on_conflict?: InputMaybe<Models_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PricesArgs = {
  objects: Array<Prices_Insert_Input>;
  on_conflict?: InputMaybe<Prices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prices_OneArgs = {
  object: Prices_Insert_Input;
  on_conflict?: InputMaybe<Prices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_DistanceArgs = {
  objects: Array<Rental_Distance_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Distance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Distance_OneArgs = {
  object: Rental_Distance_Insert_Input;
  on_conflict?: InputMaybe<Rental_Distance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_DurationArgs = {
  objects: Array<Rental_Duration_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Duration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Duration_OneArgs = {
  object: Rental_Duration_Insert_Input;
  on_conflict?: InputMaybe<Rental_Duration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TractionsArgs = {
  objects: Array<Tractions_Insert_Input>;
  on_conflict?: InputMaybe<Tractions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tractions_OneArgs = {
  object: Tractions_Insert_Input;
  on_conflict?: InputMaybe<Tractions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootSendContactEmailArgs = {
  arg1: MailInput;
};


/** mutation root */
export type Mutation_RootSubscribeNewsletterArgs = {
  arg1: SampleInput;
};


/** mutation root */
export type Mutation_RootUpdateBucketArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  pk_columns: Buckets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateBucketsArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFileArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFilesArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateVirusArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  pk_columns: Virus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateVirusesArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_OnlyArgs = {
  _inc?: InputMaybe<Admin_Only_Inc_Input>;
  _set?: InputMaybe<Admin_Only_Set_Input>;
  where: Admin_Only_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Only_By_PkArgs = {
  _inc?: InputMaybe<Admin_Only_Inc_Input>;
  _set?: InputMaybe<Admin_Only_Set_Input>;
  pk_columns: Admin_Only_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Only_ManyArgs = {
  updates: Array<Admin_Only_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BrandsArgs = {
  _set?: InputMaybe<Brands_Set_Input>;
  where: Brands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brands_By_PkArgs = {
  _set?: InputMaybe<Brands_Set_Input>;
  pk_columns: Brands_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brands_ManyArgs = {
  updates: Array<Brands_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buckets_ManyArgs = {
  updates: Array<Buckets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ModelsArgs = {
  _set?: InputMaybe<Models_Set_Input>;
  where: Models_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Models_By_PkArgs = {
  _set?: InputMaybe<Models_Set_Input>;
  pk_columns: Models_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Models_ManyArgs = {
  updates: Array<Models_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PricesArgs = {
  _inc?: InputMaybe<Prices_Inc_Input>;
  _set?: InputMaybe<Prices_Set_Input>;
  where: Prices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prices_By_PkArgs = {
  _inc?: InputMaybe<Prices_Inc_Input>;
  _set?: InputMaybe<Prices_Set_Input>;
  pk_columns: Prices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prices_ManyArgs = {
  updates: Array<Prices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_DistanceArgs = {
  _inc?: InputMaybe<Rental_Distance_Inc_Input>;
  _set?: InputMaybe<Rental_Distance_Set_Input>;
  where: Rental_Distance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Distance_By_PkArgs = {
  _inc?: InputMaybe<Rental_Distance_Inc_Input>;
  _set?: InputMaybe<Rental_Distance_Set_Input>;
  pk_columns: Rental_Distance_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Distance_ManyArgs = {
  updates: Array<Rental_Distance_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_DurationArgs = {
  _inc?: InputMaybe<Rental_Duration_Inc_Input>;
  _set?: InputMaybe<Rental_Duration_Set_Input>;
  where: Rental_Duration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Duration_By_PkArgs = {
  _inc?: InputMaybe<Rental_Duration_Inc_Input>;
  _set?: InputMaybe<Rental_Duration_Set_Input>;
  pk_columns: Rental_Duration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Duration_ManyArgs = {
  updates: Array<Rental_Duration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TractionsArgs = {
  _set?: InputMaybe<Tractions_Set_Input>;
  where: Tractions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tractions_By_PkArgs = {
  _set?: InputMaybe<Tractions_Set_Input>;
  pk_columns: Tractions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tractions_ManyArgs = {
  updates: Array<Tractions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Virus_ManyArgs = {
  updates: Array<Virus_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "prices" */
export type Prices = {
  __typename?: 'prices';
  courtesy_car_price: Scalars['numeric']['output'];
  down_payment: Scalars['numeric']['output'];
  favorite: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  model_id: Scalars['uuid']['output'];
  monthly_payment: Scalars['numeric']['output'];
  rental_distance: Scalars['Int']['output'];
  rental_duration: Scalars['Int']['output'];
  tyres_price?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "prices" */
export type Prices_Aggregate = {
  __typename?: 'prices_aggregate';
  aggregate?: Maybe<Prices_Aggregate_Fields>;
  nodes: Array<Prices>;
};

export type Prices_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Prices_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Prices_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Prices_Aggregate_Bool_Exp_Count>;
};

export type Prices_Aggregate_Bool_Exp_Bool_And = {
  arguments: Prices_Select_Column_Prices_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Prices_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Prices_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Prices_Select_Column_Prices_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Prices_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Prices_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Prices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Prices_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "prices" */
export type Prices_Aggregate_Fields = {
  __typename?: 'prices_aggregate_fields';
  avg?: Maybe<Prices_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Prices_Max_Fields>;
  min?: Maybe<Prices_Min_Fields>;
  stddev?: Maybe<Prices_Stddev_Fields>;
  stddev_pop?: Maybe<Prices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Prices_Stddev_Samp_Fields>;
  sum?: Maybe<Prices_Sum_Fields>;
  var_pop?: Maybe<Prices_Var_Pop_Fields>;
  var_samp?: Maybe<Prices_Var_Samp_Fields>;
  variance?: Maybe<Prices_Variance_Fields>;
};


/** aggregate fields of "prices" */
export type Prices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Prices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "prices" */
export type Prices_Aggregate_Order_By = {
  avg?: InputMaybe<Prices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Prices_Max_Order_By>;
  min?: InputMaybe<Prices_Min_Order_By>;
  stddev?: InputMaybe<Prices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Prices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Prices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Prices_Sum_Order_By>;
  var_pop?: InputMaybe<Prices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Prices_Var_Samp_Order_By>;
  variance?: InputMaybe<Prices_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "prices" */
export type Prices_Arr_Rel_Insert_Input = {
  data: Array<Prices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Prices_On_Conflict>;
};

/** aggregate avg on columns */
export type Prices_Avg_Fields = {
  __typename?: 'prices_avg_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "prices" */
export type Prices_Avg_Order_By = {
  courtesy_car_price?: InputMaybe<Order_By>;
  down_payment?: InputMaybe<Order_By>;
  monthly_payment?: InputMaybe<Order_By>;
  rental_distance?: InputMaybe<Order_By>;
  rental_duration?: InputMaybe<Order_By>;
  tyres_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "prices". All fields are combined with a logical 'AND'. */
export type Prices_Bool_Exp = {
  _and?: InputMaybe<Array<Prices_Bool_Exp>>;
  _not?: InputMaybe<Prices_Bool_Exp>;
  _or?: InputMaybe<Array<Prices_Bool_Exp>>;
  courtesy_car_price?: InputMaybe<Numeric_Comparison_Exp>;
  down_payment?: InputMaybe<Numeric_Comparison_Exp>;
  favorite?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  model_id?: InputMaybe<Uuid_Comparison_Exp>;
  monthly_payment?: InputMaybe<Numeric_Comparison_Exp>;
  rental_distance?: InputMaybe<Int_Comparison_Exp>;
  rental_duration?: InputMaybe<Int_Comparison_Exp>;
  tyres_price?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "prices" */
export enum Prices_Constraint {
  /** unique or primary key constraint on columns "id" */
  PricesPkey = 'prices_pkey'
}

/** input type for incrementing numeric columns in table "prices" */
export type Prices_Inc_Input = {
  courtesy_car_price?: InputMaybe<Scalars['numeric']['input']>;
  down_payment?: InputMaybe<Scalars['numeric']['input']>;
  monthly_payment?: InputMaybe<Scalars['numeric']['input']>;
  rental_distance?: InputMaybe<Scalars['Int']['input']>;
  rental_duration?: InputMaybe<Scalars['Int']['input']>;
  tyres_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "prices" */
export type Prices_Insert_Input = {
  courtesy_car_price?: InputMaybe<Scalars['numeric']['input']>;
  down_payment?: InputMaybe<Scalars['numeric']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  model_id?: InputMaybe<Scalars['uuid']['input']>;
  monthly_payment?: InputMaybe<Scalars['numeric']['input']>;
  rental_distance?: InputMaybe<Scalars['Int']['input']>;
  rental_duration?: InputMaybe<Scalars['Int']['input']>;
  tyres_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Prices_Max_Fields = {
  __typename?: 'prices_max_fields';
  courtesy_car_price?: Maybe<Scalars['numeric']['output']>;
  down_payment?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  model_id?: Maybe<Scalars['uuid']['output']>;
  monthly_payment?: Maybe<Scalars['numeric']['output']>;
  rental_distance?: Maybe<Scalars['Int']['output']>;
  rental_duration?: Maybe<Scalars['Int']['output']>;
  tyres_price?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "prices" */
export type Prices_Max_Order_By = {
  courtesy_car_price?: InputMaybe<Order_By>;
  down_payment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  monthly_payment?: InputMaybe<Order_By>;
  rental_distance?: InputMaybe<Order_By>;
  rental_duration?: InputMaybe<Order_By>;
  tyres_price?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Prices_Min_Fields = {
  __typename?: 'prices_min_fields';
  courtesy_car_price?: Maybe<Scalars['numeric']['output']>;
  down_payment?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  model_id?: Maybe<Scalars['uuid']['output']>;
  monthly_payment?: Maybe<Scalars['numeric']['output']>;
  rental_distance?: Maybe<Scalars['Int']['output']>;
  rental_duration?: Maybe<Scalars['Int']['output']>;
  tyres_price?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "prices" */
export type Prices_Min_Order_By = {
  courtesy_car_price?: InputMaybe<Order_By>;
  down_payment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  monthly_payment?: InputMaybe<Order_By>;
  rental_distance?: InputMaybe<Order_By>;
  rental_duration?: InputMaybe<Order_By>;
  tyres_price?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "prices" */
export type Prices_Mutation_Response = {
  __typename?: 'prices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Prices>;
};

/** on_conflict condition type for table "prices" */
export type Prices_On_Conflict = {
  constraint: Prices_Constraint;
  update_columns?: Array<Prices_Update_Column>;
  where?: InputMaybe<Prices_Bool_Exp>;
};

/** Ordering options when selecting data from "prices". */
export type Prices_Order_By = {
  courtesy_car_price?: InputMaybe<Order_By>;
  down_payment?: InputMaybe<Order_By>;
  favorite?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  monthly_payment?: InputMaybe<Order_By>;
  rental_distance?: InputMaybe<Order_By>;
  rental_duration?: InputMaybe<Order_By>;
  tyres_price?: InputMaybe<Order_By>;
};

/** primary key columns input for table: prices */
export type Prices_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "prices" */
export enum Prices_Select_Column {
  /** column name */
  CourtesyCarPrice = 'courtesy_car_price',
  /** column name */
  DownPayment = 'down_payment',
  /** column name */
  Favorite = 'favorite',
  /** column name */
  Id = 'id',
  /** column name */
  ModelId = 'model_id',
  /** column name */
  MonthlyPayment = 'monthly_payment',
  /** column name */
  RentalDistance = 'rental_distance',
  /** column name */
  RentalDuration = 'rental_duration',
  /** column name */
  TyresPrice = 'tyres_price'
}

/** select "prices_aggregate_bool_exp_bool_and_arguments_columns" columns of table "prices" */
export enum Prices_Select_Column_Prices_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Favorite = 'favorite'
}

/** select "prices_aggregate_bool_exp_bool_or_arguments_columns" columns of table "prices" */
export enum Prices_Select_Column_Prices_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Favorite = 'favorite'
}

/** input type for updating data in table "prices" */
export type Prices_Set_Input = {
  courtesy_car_price?: InputMaybe<Scalars['numeric']['input']>;
  down_payment?: InputMaybe<Scalars['numeric']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  model_id?: InputMaybe<Scalars['uuid']['input']>;
  monthly_payment?: InputMaybe<Scalars['numeric']['input']>;
  rental_distance?: InputMaybe<Scalars['Int']['input']>;
  rental_duration?: InputMaybe<Scalars['Int']['input']>;
  tyres_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Prices_Stddev_Fields = {
  __typename?: 'prices_stddev_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "prices" */
export type Prices_Stddev_Order_By = {
  courtesy_car_price?: InputMaybe<Order_By>;
  down_payment?: InputMaybe<Order_By>;
  monthly_payment?: InputMaybe<Order_By>;
  rental_distance?: InputMaybe<Order_By>;
  rental_duration?: InputMaybe<Order_By>;
  tyres_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Prices_Stddev_Pop_Fields = {
  __typename?: 'prices_stddev_pop_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "prices" */
export type Prices_Stddev_Pop_Order_By = {
  courtesy_car_price?: InputMaybe<Order_By>;
  down_payment?: InputMaybe<Order_By>;
  monthly_payment?: InputMaybe<Order_By>;
  rental_distance?: InputMaybe<Order_By>;
  rental_duration?: InputMaybe<Order_By>;
  tyres_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Prices_Stddev_Samp_Fields = {
  __typename?: 'prices_stddev_samp_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "prices" */
export type Prices_Stddev_Samp_Order_By = {
  courtesy_car_price?: InputMaybe<Order_By>;
  down_payment?: InputMaybe<Order_By>;
  monthly_payment?: InputMaybe<Order_By>;
  rental_distance?: InputMaybe<Order_By>;
  rental_duration?: InputMaybe<Order_By>;
  tyres_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "prices" */
export type Prices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prices_Stream_Cursor_Value_Input = {
  courtesy_car_price?: InputMaybe<Scalars['numeric']['input']>;
  down_payment?: InputMaybe<Scalars['numeric']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  model_id?: InputMaybe<Scalars['uuid']['input']>;
  monthly_payment?: InputMaybe<Scalars['numeric']['input']>;
  rental_distance?: InputMaybe<Scalars['Int']['input']>;
  rental_duration?: InputMaybe<Scalars['Int']['input']>;
  tyres_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Prices_Sum_Fields = {
  __typename?: 'prices_sum_fields';
  courtesy_car_price?: Maybe<Scalars['numeric']['output']>;
  down_payment?: Maybe<Scalars['numeric']['output']>;
  monthly_payment?: Maybe<Scalars['numeric']['output']>;
  rental_distance?: Maybe<Scalars['Int']['output']>;
  rental_duration?: Maybe<Scalars['Int']['output']>;
  tyres_price?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "prices" */
export type Prices_Sum_Order_By = {
  courtesy_car_price?: InputMaybe<Order_By>;
  down_payment?: InputMaybe<Order_By>;
  monthly_payment?: InputMaybe<Order_By>;
  rental_distance?: InputMaybe<Order_By>;
  rental_duration?: InputMaybe<Order_By>;
  tyres_price?: InputMaybe<Order_By>;
};

/** update columns of table "prices" */
export enum Prices_Update_Column {
  /** column name */
  CourtesyCarPrice = 'courtesy_car_price',
  /** column name */
  DownPayment = 'down_payment',
  /** column name */
  Favorite = 'favorite',
  /** column name */
  Id = 'id',
  /** column name */
  ModelId = 'model_id',
  /** column name */
  MonthlyPayment = 'monthly_payment',
  /** column name */
  RentalDistance = 'rental_distance',
  /** column name */
  RentalDuration = 'rental_duration',
  /** column name */
  TyresPrice = 'tyres_price'
}

export type Prices_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Prices_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prices_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Prices_Var_Pop_Fields = {
  __typename?: 'prices_var_pop_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "prices" */
export type Prices_Var_Pop_Order_By = {
  courtesy_car_price?: InputMaybe<Order_By>;
  down_payment?: InputMaybe<Order_By>;
  monthly_payment?: InputMaybe<Order_By>;
  rental_distance?: InputMaybe<Order_By>;
  rental_duration?: InputMaybe<Order_By>;
  tyres_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Prices_Var_Samp_Fields = {
  __typename?: 'prices_var_samp_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "prices" */
export type Prices_Var_Samp_Order_By = {
  courtesy_car_price?: InputMaybe<Order_By>;
  down_payment?: InputMaybe<Order_By>;
  monthly_payment?: InputMaybe<Order_By>;
  rental_distance?: InputMaybe<Order_By>;
  rental_duration?: InputMaybe<Order_By>;
  tyres_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Prices_Variance_Fields = {
  __typename?: 'prices_variance_fields';
  courtesy_car_price?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  rental_distance?: Maybe<Scalars['Float']['output']>;
  rental_duration?: Maybe<Scalars['Float']['output']>;
  tyres_price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "prices" */
export type Prices_Variance_Order_By = {
  courtesy_car_price?: InputMaybe<Order_By>;
  down_payment?: InputMaybe<Order_By>;
  monthly_payment?: InputMaybe<Order_By>;
  rental_distance?: InputMaybe<Order_By>;
  rental_duration?: InputMaybe<Order_By>;
  tyres_price?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  _node?: Maybe<_Node>;
  _nodes: Array<Maybe<_Node>>;
  /** fetch data from the table: "admin_only" */
  admin_only: Array<Admin_Only>;
  /** fetch aggregated fields from the table: "admin_only" */
  admin_only_aggregate: Admin_Only_Aggregate;
  /** fetch data from the table: "admin_only" using primary key columns */
  admin_only_by_pk?: Maybe<Admin_Only>;
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  /** fetch data from the table: "brands" */
  brands: Array<Brands>;
  /** fetch aggregated fields from the table: "brands" */
  brands_aggregate: Brands_Aggregate;
  /** fetch data from the table: "brands" using primary key columns */
  brands_by_pk?: Maybe<Brands>;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  copertina?: Maybe<Copertina>;
  copertinaCollection?: Maybe<CopertinaCollection>;
  descriptiveBlock?: Maybe<DescriptiveBlock>;
  descriptiveBlockCollection?: Maybe<DescriptiveBlockCollection>;
  entryCollection?: Maybe<EntryCollection>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** fetch data from the table: "final_prices" */
  final_prices: Array<Final_Prices>;
  /** fetch aggregated fields from the table: "final_prices" */
  final_prices_aggregate: Final_Prices_Aggregate;
  fisco?: Maybe<Fisco>;
  fiscoCollection?: Maybe<FiscoCollection>;
  getRunsLast?: Maybe<Array<Maybe<Review>>>;
  /** An array relationship */
  models: Array<Models>;
  /** An aggregate relationship */
  models_aggregate: Models_Aggregate;
  /** fetch data from the table: "models" using primary key columns */
  models_by_pk?: Maybe<Models>;
  /** An array relationship */
  prices: Array<Prices>;
  /** An aggregate relationship */
  prices_aggregate: Prices_Aggregate;
  /** fetch data from the table: "prices" using primary key columns */
  prices_by_pk?: Maybe<Prices>;
  /** fetch data from the table: "rental_distance" */
  rental_distance: Array<Rental_Distance>;
  /** fetch aggregated fields from the table: "rental_distance" */
  rental_distance_aggregate: Rental_Distance_Aggregate;
  /** fetch data from the table: "rental_distance" using primary key columns */
  rental_distance_by_pk?: Maybe<Rental_Distance>;
  /** fetch data from the table: "rental_duration" */
  rental_duration: Array<Rental_Duration>;
  /** fetch aggregated fields from the table: "rental_duration" */
  rental_duration_aggregate: Rental_Duration_Aggregate;
  /** fetch data from the table: "rental_duration" using primary key columns */
  rental_duration_by_pk?: Maybe<Rental_Duration>;
  /** fetch data from the table: "tractions" */
  tractions: Array<Tractions>;
  /** fetch aggregated fields from the table: "tractions" */
  tractions_aggregate: Tractions_Aggregate;
  /** fetch data from the table: "tractions" using primary key columns */
  tractions_by_pk?: Maybe<Tractions>;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
};


export type Query_Root_NodeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_Root_NodesArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_RootAdmin_OnlyArgs = {
  distinct_on?: InputMaybe<Array<Admin_Only_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Only_Order_By>>;
  where?: InputMaybe<Admin_Only_Bool_Exp>;
};


export type Query_RootAdmin_Only_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Only_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Only_Order_By>>;
  where?: InputMaybe<Admin_Only_Bool_Exp>;
};


export type Query_RootAdmin_Only_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootAssetArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_RootAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetFilter>;
};


export type Query_RootBrandsArgs = {
  distinct_on?: InputMaybe<Array<Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brands_Order_By>>;
  where?: InputMaybe<Brands_Bool_Exp>;
};


export type Query_RootBrands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brands_Order_By>>;
  where?: InputMaybe<Brands_Bool_Exp>;
};


export type Query_RootBrands_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootBucketArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootCopertinaArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_RootCopertinaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CopertinaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CopertinaFilter>;
};


export type Query_RootDescriptiveBlockArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_RootDescriptiveBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DescriptiveBlockOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DescriptiveBlockFilter>;
};


export type Query_RootEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EntryFilter>;
};


export type Query_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFinal_PricesArgs = {
  distinct_on?: InputMaybe<Array<Final_Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Final_Prices_Order_By>>;
  where?: InputMaybe<Final_Prices_Bool_Exp>;
};


export type Query_RootFinal_Prices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Final_Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Final_Prices_Order_By>>;
  where?: InputMaybe<Final_Prices_Bool_Exp>;
};


export type Query_RootFiscoArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_RootFiscoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FiscoOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FiscoFilter>;
};


export type Query_RootModelsArgs = {
  distinct_on?: InputMaybe<Array<Models_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Models_Order_By>>;
  where?: InputMaybe<Models_Bool_Exp>;
};


export type Query_RootModels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Models_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Models_Order_By>>;
  where?: InputMaybe<Models_Bool_Exp>;
};


export type Query_RootModels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPricesArgs = {
  distinct_on?: InputMaybe<Array<Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prices_Order_By>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};


export type Query_RootPrices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prices_Order_By>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};


export type Query_RootPrices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Rental_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Distance_Order_By>>;
  where?: InputMaybe<Rental_Distance_Bool_Exp>;
};


export type Query_RootRental_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Distance_Order_By>>;
  where?: InputMaybe<Rental_Distance_Bool_Exp>;
};


export type Query_RootRental_Distance_By_PkArgs = {
  km: Scalars['Int']['input'];
};


export type Query_RootRental_DurationArgs = {
  distinct_on?: InputMaybe<Array<Rental_Duration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Duration_Order_By>>;
  where?: InputMaybe<Rental_Duration_Bool_Exp>;
};


export type Query_RootRental_Duration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Duration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Duration_Order_By>>;
  where?: InputMaybe<Rental_Duration_Bool_Exp>;
};


export type Query_RootRental_Duration_By_PkArgs = {
  months: Scalars['Int']['input'];
};


export type Query_RootTractionsArgs = {
  distinct_on?: InputMaybe<Array<Tractions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tractions_Order_By>>;
  where?: InputMaybe<Tractions_Bool_Exp>;
};


export type Query_RootTractions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tractions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tractions_Order_By>>;
  where?: InputMaybe<Tractions_Bool_Exp>;
};


export type Query_RootTractions_By_PkArgs = {
  kind: Scalars['String']['input'];
};


export type Query_RootVirusArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Query_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};

/** columns and relationships of "rental_distance" */
export type Rental_Distance = {
  __typename?: 'rental_distance';
  km: Scalars['Int']['output'];
};

/** aggregated selection of "rental_distance" */
export type Rental_Distance_Aggregate = {
  __typename?: 'rental_distance_aggregate';
  aggregate?: Maybe<Rental_Distance_Aggregate_Fields>;
  nodes: Array<Rental_Distance>;
};

/** aggregate fields of "rental_distance" */
export type Rental_Distance_Aggregate_Fields = {
  __typename?: 'rental_distance_aggregate_fields';
  avg?: Maybe<Rental_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Rental_Distance_Max_Fields>;
  min?: Maybe<Rental_Distance_Min_Fields>;
  stddev?: Maybe<Rental_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Rental_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rental_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Rental_Distance_Sum_Fields>;
  var_pop?: Maybe<Rental_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Rental_Distance_Var_Samp_Fields>;
  variance?: Maybe<Rental_Distance_Variance_Fields>;
};


/** aggregate fields of "rental_distance" */
export type Rental_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rental_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Rental_Distance_Avg_Fields = {
  __typename?: 'rental_distance_avg_fields';
  km?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "rental_distance". All fields are combined with a logical 'AND'. */
export type Rental_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Distance_Bool_Exp>>;
  _not?: InputMaybe<Rental_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Distance_Bool_Exp>>;
  km?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_distance" */
export enum Rental_Distance_Constraint {
  /** unique or primary key constraint on columns "km" */
  RentalDistancePkey = 'rental_distance_pkey'
}

/** input type for incrementing numeric columns in table "rental_distance" */
export type Rental_Distance_Inc_Input = {
  km?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "rental_distance" */
export type Rental_Distance_Insert_Input = {
  km?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Rental_Distance_Max_Fields = {
  __typename?: 'rental_distance_max_fields';
  km?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Rental_Distance_Min_Fields = {
  __typename?: 'rental_distance_min_fields';
  km?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "rental_distance" */
export type Rental_Distance_Mutation_Response = {
  __typename?: 'rental_distance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Distance>;
};

/** on_conflict condition type for table "rental_distance" */
export type Rental_Distance_On_Conflict = {
  constraint: Rental_Distance_Constraint;
  update_columns?: Array<Rental_Distance_Update_Column>;
  where?: InputMaybe<Rental_Distance_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_distance". */
export type Rental_Distance_Order_By = {
  km?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_distance */
export type Rental_Distance_Pk_Columns_Input = {
  km: Scalars['Int']['input'];
};

/** select columns of table "rental_distance" */
export enum Rental_Distance_Select_Column {
  /** column name */
  Km = 'km'
}

/** input type for updating data in table "rental_distance" */
export type Rental_Distance_Set_Input = {
  km?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Rental_Distance_Stddev_Fields = {
  __typename?: 'rental_distance_stddev_fields';
  km?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Rental_Distance_Stddev_Pop_Fields = {
  __typename?: 'rental_distance_stddev_pop_fields';
  km?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Rental_Distance_Stddev_Samp_Fields = {
  __typename?: 'rental_distance_stddev_samp_fields';
  km?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "rental_distance" */
export type Rental_Distance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Distance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Distance_Stream_Cursor_Value_Input = {
  km?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Rental_Distance_Sum_Fields = {
  __typename?: 'rental_distance_sum_fields';
  km?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "rental_distance" */
export enum Rental_Distance_Update_Column {
  /** column name */
  Km = 'km'
}

export type Rental_Distance_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rental_Distance_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Distance_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rental_Distance_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rental_Distance_Var_Pop_Fields = {
  __typename?: 'rental_distance_var_pop_fields';
  km?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Rental_Distance_Var_Samp_Fields = {
  __typename?: 'rental_distance_var_samp_fields';
  km?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Rental_Distance_Variance_Fields = {
  __typename?: 'rental_distance_variance_fields';
  km?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "rental_duration" */
export type Rental_Duration = {
  __typename?: 'rental_duration';
  months: Scalars['Int']['output'];
};

/** aggregated selection of "rental_duration" */
export type Rental_Duration_Aggregate = {
  __typename?: 'rental_duration_aggregate';
  aggregate?: Maybe<Rental_Duration_Aggregate_Fields>;
  nodes: Array<Rental_Duration>;
};

/** aggregate fields of "rental_duration" */
export type Rental_Duration_Aggregate_Fields = {
  __typename?: 'rental_duration_aggregate_fields';
  avg?: Maybe<Rental_Duration_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Rental_Duration_Max_Fields>;
  min?: Maybe<Rental_Duration_Min_Fields>;
  stddev?: Maybe<Rental_Duration_Stddev_Fields>;
  stddev_pop?: Maybe<Rental_Duration_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rental_Duration_Stddev_Samp_Fields>;
  sum?: Maybe<Rental_Duration_Sum_Fields>;
  var_pop?: Maybe<Rental_Duration_Var_Pop_Fields>;
  var_samp?: Maybe<Rental_Duration_Var_Samp_Fields>;
  variance?: Maybe<Rental_Duration_Variance_Fields>;
};


/** aggregate fields of "rental_duration" */
export type Rental_Duration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rental_Duration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Rental_Duration_Avg_Fields = {
  __typename?: 'rental_duration_avg_fields';
  months?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "rental_duration". All fields are combined with a logical 'AND'. */
export type Rental_Duration_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Duration_Bool_Exp>>;
  _not?: InputMaybe<Rental_Duration_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Duration_Bool_Exp>>;
  months?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_duration" */
export enum Rental_Duration_Constraint {
  /** unique or primary key constraint on columns "months" */
  RentalDurationPkey = 'rental_duration_pkey'
}

/** input type for incrementing numeric columns in table "rental_duration" */
export type Rental_Duration_Inc_Input = {
  months?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "rental_duration" */
export type Rental_Duration_Insert_Input = {
  months?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Rental_Duration_Max_Fields = {
  __typename?: 'rental_duration_max_fields';
  months?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Rental_Duration_Min_Fields = {
  __typename?: 'rental_duration_min_fields';
  months?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "rental_duration" */
export type Rental_Duration_Mutation_Response = {
  __typename?: 'rental_duration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Duration>;
};

/** on_conflict condition type for table "rental_duration" */
export type Rental_Duration_On_Conflict = {
  constraint: Rental_Duration_Constraint;
  update_columns?: Array<Rental_Duration_Update_Column>;
  where?: InputMaybe<Rental_Duration_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_duration". */
export type Rental_Duration_Order_By = {
  months?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_duration */
export type Rental_Duration_Pk_Columns_Input = {
  months: Scalars['Int']['input'];
};

/** select columns of table "rental_duration" */
export enum Rental_Duration_Select_Column {
  /** column name */
  Months = 'months'
}

/** input type for updating data in table "rental_duration" */
export type Rental_Duration_Set_Input = {
  months?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Rental_Duration_Stddev_Fields = {
  __typename?: 'rental_duration_stddev_fields';
  months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Rental_Duration_Stddev_Pop_Fields = {
  __typename?: 'rental_duration_stddev_pop_fields';
  months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Rental_Duration_Stddev_Samp_Fields = {
  __typename?: 'rental_duration_stddev_samp_fields';
  months?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "rental_duration" */
export type Rental_Duration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Duration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Duration_Stream_Cursor_Value_Input = {
  months?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Rental_Duration_Sum_Fields = {
  __typename?: 'rental_duration_sum_fields';
  months?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "rental_duration" */
export enum Rental_Duration_Update_Column {
  /** column name */
  Months = 'months'
}

export type Rental_Duration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rental_Duration_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Duration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rental_Duration_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rental_Duration_Var_Pop_Fields = {
  __typename?: 'rental_duration_var_pop_fields';
  months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Rental_Duration_Var_Samp_Fields = {
  __typename?: 'rental_duration_var_samp_fields';
  months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Rental_Duration_Variance_Fields = {
  __typename?: 'rental_duration_variance_fields';
  months?: Maybe<Scalars['Float']['output']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "admin_only" */
  admin_only: Array<Admin_Only>;
  /** fetch aggregated fields from the table: "admin_only" */
  admin_only_aggregate: Admin_Only_Aggregate;
  /** fetch data from the table: "admin_only" using primary key columns */
  admin_only_by_pk?: Maybe<Admin_Only>;
  /** fetch data from the table in a streaming manner: "admin_only" */
  admin_only_stream: Array<Admin_Only>;
  /** fetch data from the table: "brands" */
  brands: Array<Brands>;
  /** fetch aggregated fields from the table: "brands" */
  brands_aggregate: Brands_Aggregate;
  /** fetch data from the table: "brands" using primary key columns */
  brands_by_pk?: Maybe<Brands>;
  /** fetch data from the table in a streaming manner: "brands" */
  brands_stream: Array<Brands>;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.buckets" */
  buckets_stream: Array<Buckets>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.files" */
  files_stream: Array<Files>;
  /** fetch data from the table: "final_prices" */
  final_prices: Array<Final_Prices>;
  /** fetch aggregated fields from the table: "final_prices" */
  final_prices_aggregate: Final_Prices_Aggregate;
  /** fetch data from the table in a streaming manner: "final_prices" */
  final_prices_stream: Array<Final_Prices>;
  /** An array relationship */
  models: Array<Models>;
  /** An aggregate relationship */
  models_aggregate: Models_Aggregate;
  /** fetch data from the table: "models" using primary key columns */
  models_by_pk?: Maybe<Models>;
  /** fetch data from the table in a streaming manner: "models" */
  models_stream: Array<Models>;
  /** An array relationship */
  prices: Array<Prices>;
  /** An aggregate relationship */
  prices_aggregate: Prices_Aggregate;
  /** fetch data from the table: "prices" using primary key columns */
  prices_by_pk?: Maybe<Prices>;
  /** fetch data from the table in a streaming manner: "prices" */
  prices_stream: Array<Prices>;
  /** fetch data from the table: "rental_distance" */
  rental_distance: Array<Rental_Distance>;
  /** fetch aggregated fields from the table: "rental_distance" */
  rental_distance_aggregate: Rental_Distance_Aggregate;
  /** fetch data from the table: "rental_distance" using primary key columns */
  rental_distance_by_pk?: Maybe<Rental_Distance>;
  /** fetch data from the table in a streaming manner: "rental_distance" */
  rental_distance_stream: Array<Rental_Distance>;
  /** fetch data from the table: "rental_duration" */
  rental_duration: Array<Rental_Duration>;
  /** fetch aggregated fields from the table: "rental_duration" */
  rental_duration_aggregate: Rental_Duration_Aggregate;
  /** fetch data from the table: "rental_duration" using primary key columns */
  rental_duration_by_pk?: Maybe<Rental_Duration>;
  /** fetch data from the table in a streaming manner: "rental_duration" */
  rental_duration_stream: Array<Rental_Duration>;
  /** fetch data from the table: "tractions" */
  tractions: Array<Tractions>;
  /** fetch aggregated fields from the table: "tractions" */
  tractions_aggregate: Tractions_Aggregate;
  /** fetch data from the table: "tractions" using primary key columns */
  tractions_by_pk?: Maybe<Tractions>;
  /** fetch data from the table in a streaming manner: "tractions" */
  tractions_stream: Array<Tractions>;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table in a streaming manner: "storage.virus" */
  virus_stream: Array<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
};


export type Subscription_RootAdmin_OnlyArgs = {
  distinct_on?: InputMaybe<Array<Admin_Only_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Only_Order_By>>;
  where?: InputMaybe<Admin_Only_Bool_Exp>;
};


export type Subscription_RootAdmin_Only_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Only_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Only_Order_By>>;
  where?: InputMaybe<Admin_Only_Bool_Exp>;
};


export type Subscription_RootAdmin_Only_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootAdmin_Only_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_Only_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_Only_Bool_Exp>;
};


export type Subscription_RootBrandsArgs = {
  distinct_on?: InputMaybe<Array<Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brands_Order_By>>;
  where?: InputMaybe<Brands_Bool_Exp>;
};


export type Subscription_RootBrands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brands_Order_By>>;
  where?: InputMaybe<Brands_Bool_Exp>;
};


export type Subscription_RootBrands_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootBrands_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brands_Stream_Cursor_Input>>;
  where?: InputMaybe<Brands_Bool_Exp>;
};


export type Subscription_RootBucketArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBuckets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buckets_Stream_Cursor_Input>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFinal_PricesArgs = {
  distinct_on?: InputMaybe<Array<Final_Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Final_Prices_Order_By>>;
  where?: InputMaybe<Final_Prices_Bool_Exp>;
};


export type Subscription_RootFinal_Prices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Final_Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Final_Prices_Order_By>>;
  where?: InputMaybe<Final_Prices_Bool_Exp>;
};


export type Subscription_RootFinal_Prices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Final_Prices_Stream_Cursor_Input>>;
  where?: InputMaybe<Final_Prices_Bool_Exp>;
};


export type Subscription_RootModelsArgs = {
  distinct_on?: InputMaybe<Array<Models_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Models_Order_By>>;
  where?: InputMaybe<Models_Bool_Exp>;
};


export type Subscription_RootModels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Models_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Models_Order_By>>;
  where?: InputMaybe<Models_Bool_Exp>;
};


export type Subscription_RootModels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootModels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Models_Stream_Cursor_Input>>;
  where?: InputMaybe<Models_Bool_Exp>;
};


export type Subscription_RootPricesArgs = {
  distinct_on?: InputMaybe<Array<Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prices_Order_By>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};


export type Subscription_RootPrices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prices_Order_By>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};


export type Subscription_RootPrices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPrices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Prices_Stream_Cursor_Input>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};


export type Subscription_RootRental_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Rental_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Distance_Order_By>>;
  where?: InputMaybe<Rental_Distance_Bool_Exp>;
};


export type Subscription_RootRental_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Distance_Order_By>>;
  where?: InputMaybe<Rental_Distance_Bool_Exp>;
};


export type Subscription_RootRental_Distance_By_PkArgs = {
  km: Scalars['Int']['input'];
};


export type Subscription_RootRental_Distance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Distance_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Distance_Bool_Exp>;
};


export type Subscription_RootRental_DurationArgs = {
  distinct_on?: InputMaybe<Array<Rental_Duration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Duration_Order_By>>;
  where?: InputMaybe<Rental_Duration_Bool_Exp>;
};


export type Subscription_RootRental_Duration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Duration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Duration_Order_By>>;
  where?: InputMaybe<Rental_Duration_Bool_Exp>;
};


export type Subscription_RootRental_Duration_By_PkArgs = {
  months: Scalars['Int']['input'];
};


export type Subscription_RootRental_Duration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Duration_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Duration_Bool_Exp>;
};


export type Subscription_RootTractionsArgs = {
  distinct_on?: InputMaybe<Array<Tractions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tractions_Order_By>>;
  where?: InputMaybe<Tractions_Bool_Exp>;
};


export type Subscription_RootTractions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tractions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tractions_Order_By>>;
  where?: InputMaybe<Tractions_Bool_Exp>;
};


export type Subscription_RootTractions_By_PkArgs = {
  kind: Scalars['String']['input'];
};


export type Subscription_RootTractions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tractions_Stream_Cursor_Input>>;
  where?: InputMaybe<Tractions_Bool_Exp>;
};


export type Subscription_RootVirusArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVirus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Virus_Stream_Cursor_Input>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "tractions" */
export type Tractions = {
  __typename?: 'tractions';
  description?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
};

/** aggregated selection of "tractions" */
export type Tractions_Aggregate = {
  __typename?: 'tractions_aggregate';
  aggregate?: Maybe<Tractions_Aggregate_Fields>;
  nodes: Array<Tractions>;
};

/** aggregate fields of "tractions" */
export type Tractions_Aggregate_Fields = {
  __typename?: 'tractions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tractions_Max_Fields>;
  min?: Maybe<Tractions_Min_Fields>;
};


/** aggregate fields of "tractions" */
export type Tractions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tractions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tractions". All fields are combined with a logical 'AND'. */
export type Tractions_Bool_Exp = {
  _and?: InputMaybe<Array<Tractions_Bool_Exp>>;
  _not?: InputMaybe<Tractions_Bool_Exp>;
  _or?: InputMaybe<Array<Tractions_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tractions" */
export enum Tractions_Constraint {
  /** unique or primary key constraint on columns "kind" */
  TractionsPkey = 'tractions_pkey'
}

export enum Tractions_Enum {
  /** Benzina */
  Benzina = 'benzina',
  /** Benzina full hybrid */
  BenzinaFullHybrid = 'benzina_full_hybrid',
  /** Benzina mild hybrid */
  BenzinaMildHybrid = 'benzina_mild_hybrid',
  /** Benzina plug-in */
  BenzinaPlugIn = 'benzina_plug_in',
  /** Diesel */
  Diesel = 'diesel',
  /** Diesel mild hybrid */
  DieselMildHybrid = 'diesel_mild_hybrid',
  /** Diesel plug-in */
  DieselPlugIn = 'diesel_plug_in',
  /** Elettrica */
  Elettrica = 'elettrica',
  /** Ibrida */
  Ibrida = 'ibrida'
}

/** Boolean expression to compare columns of type "tractions_enum". All fields are combined with logical 'AND'. */
export type Tractions_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Tractions_Enum>;
  _in?: InputMaybe<Array<Tractions_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Tractions_Enum>;
  _nin?: InputMaybe<Array<Tractions_Enum>>;
};

/** input type for inserting data into table "tractions" */
export type Tractions_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tractions_Max_Fields = {
  __typename?: 'tractions_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tractions_Min_Fields = {
  __typename?: 'tractions_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tractions" */
export type Tractions_Mutation_Response = {
  __typename?: 'tractions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tractions>;
};

/** input type for inserting object relation for remote table "tractions" */
export type Tractions_Obj_Rel_Insert_Input = {
  data: Tractions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tractions_On_Conflict>;
};

/** on_conflict condition type for table "tractions" */
export type Tractions_On_Conflict = {
  constraint: Tractions_Constraint;
  update_columns?: Array<Tractions_Update_Column>;
  where?: InputMaybe<Tractions_Bool_Exp>;
};

/** Ordering options when selecting data from "tractions". */
export type Tractions_Order_By = {
  description?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tractions */
export type Tractions_Pk_Columns_Input = {
  kind: Scalars['String']['input'];
};

/** select columns of table "tractions" */
export enum Tractions_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

/** input type for updating data in table "tractions" */
export type Tractions_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tractions" */
export type Tractions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tractions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tractions_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tractions" */
export enum Tractions_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

export type Tractions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tractions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tractions_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "storage.virus" */
export type Virus = {
  __typename?: 'virus';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  fileId: Scalars['uuid']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userSession: Scalars['jsonb']['output'];
  virus: Scalars['String']['output'];
};


/** columns and relationships of "storage.virus" */
export type VirusUserSessionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.virus" */
export type Virus_Aggregate = {
  __typename?: 'virus_aggregate';
  aggregate?: Maybe<Virus_Aggregate_Fields>;
  nodes: Array<Virus>;
};

/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_Fields = {
  __typename?: 'virus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Virus_Max_Fields>;
  min?: Maybe<Virus_Min_Fields>;
};


/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Virus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Virus_Append_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "storage.virus". All fields are combined with a logical 'AND'. */
export type Virus_Bool_Exp = {
  _and?: InputMaybe<Array<Virus_Bool_Exp>>;
  _not?: InputMaybe<Virus_Bool_Exp>;
  _or?: InputMaybe<Array<Virus_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userSession?: InputMaybe<Jsonb_Comparison_Exp>;
  virus?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.virus" */
export enum Virus_Constraint {
  /** unique or primary key constraint on columns "id" */
  VirusPkey = 'virus_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Virus_Delete_At_Path_Input = {
  userSession?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Virus_Delete_Elem_Input = {
  userSession?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Virus_Delete_Key_Input = {
  userSession?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "storage.virus" */
export type Virus_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Virus_Max_Fields = {
  __typename?: 'virus_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Virus_Min_Fields = {
  __typename?: 'virus_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storage.virus" */
export type Virus_Mutation_Response = {
  __typename?: 'virus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Virus>;
};

/** on_conflict condition type for table "storage.virus" */
export type Virus_On_Conflict = {
  constraint: Virus_Constraint;
  update_columns?: Array<Virus_Update_Column>;
  where?: InputMaybe<Virus_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.virus". */
export type Virus_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userSession?: InputMaybe<Order_By>;
  virus?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.virus */
export type Virus_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Virus_Prepend_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.virus" */
export enum Virus_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

/** input type for updating data in table "storage.virus" */
export type Virus_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "virus" */
export type Virus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Virus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Virus_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storage.virus" */
export enum Virus_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

export type Virus_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Virus_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Virus_Set_Input>;
  /** filter the rows which have to be updated */
  where: Virus_Bool_Exp;
};

export type BrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandsQuery = { __typename?: 'query_root', brands: Array<{ __typename?: 'brands', name: string }> };

export type InsertBrandMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertBrandMutation = { __typename?: 'mutation_root', insert_brands_one?: { __typename?: 'brands', name: string } | null };

export type DeleteBrandMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteBrandMutation = { __typename?: 'mutation_root', delete_brands_by_pk?: { __typename?: 'brands', name: string } | null };

export type ModelQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ModelQuery = { __typename?: 'query_root', models_by_pk?: { __typename?: 'models', brand: string, engine: string, model_name: string, id: any, traction_type: Tractions_Enum, furgone: boolean, imgs?: Array<string> | null, prices: Array<{ __typename?: 'prices', down_payment: any, courtesy_car_price: any, id: any, monthly_payment: any, rental_distance: number, rental_duration: number, tyres_price?: any | null, favorite: boolean }> } | null };

export type ModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type ModelsQuery = { __typename?: 'query_root', models: Array<{ __typename?: 'models', brand: string, engine: string, model_name: string, id: any }> };

export type UpdateModelMutationVariables = Exact<{
  brand?: InputMaybe<Scalars['String']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['uuid']['input'];
  model_name?: InputMaybe<Scalars['String']['input']>;
  traction_type?: InputMaybe<Tractions_Enum>;
  imgs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  furgone?: InputMaybe<Scalars['Boolean']['input']>;
  prices: Array<Prices_Insert_Input> | Prices_Insert_Input;
}>;


export type UpdateModelMutation = { __typename?: 'mutation_root', insert_models_one?: { __typename?: 'models', brand: string, engine: string, id: any, imgs?: Array<string> | null, model_name: string, new_driving_license: boolean, traction_type: Tractions_Enum } | null };

export type FinalPricesQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  distance?: InputMaybe<Scalars['Int']['input']>;
  courtesy_car?: InputMaybe<Scalars['Boolean']['input']>;
  tyres?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FinalPricesQuery = { __typename?: 'query_root', final_prices: Array<{ __typename?: 'final_prices', final_monthly_price?: any | null, down_payment?: any | null }>, models_by_pk?: { __typename?: 'models', traction_type: Tractions_Enum, model_name: string, imgs?: Array<string> | null, furgone: boolean, engine: string, brand: string } | null };

export type NewCarMutationVariables = Exact<{
  courtesy_car_price?: InputMaybe<Scalars['numeric']['input']>;
  down_payment?: InputMaybe<Scalars['numeric']['input']>;
  tyre_price?: InputMaybe<Scalars['numeric']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewCarMutation = { __typename?: 'mutation_root', insert_models_one?: { __typename?: 'models', new_driving_license: boolean, traction_type: Tractions_Enum, id: any } | null };

export type DeleteModelMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteModelMutation = { __typename?: 'mutation_root', delete_models_by_pk?: { __typename?: 'models', id: any } | null };

export type SearchQueryVariables = Exact<{
  brand?: InputMaybe<Scalars['String']['input']>;
  furgone?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchQuery = { __typename?: 'query_root', models: Array<{ __typename?: 'models', model_name: string, id: any }>, brands: Array<{ __typename?: 'brands', name: string }> };

export type ModelInfoQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ModelInfoQuery = { __typename?: 'query_root', models_by_pk?: { __typename?: 'models', imgs?: Array<string> | null, brand: string, model_name: string, furgone: boolean, engine: string, traction_type: Tractions_Enum } | null };

export type CarForCardQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type CarForCardQuery = { __typename?: 'query_root', models_by_pk?: { __typename?: 'models', brand: string, engine: string, imgs?: Array<string> | null, model_name: string, id: any, traction_type: Tractions_Enum, prices: Array<{ __typename?: 'prices', monthly_payment: any, down_payment: any, rental_distance: number, rental_duration: number, favorite: boolean }> } | null };

export type DescriptiveBlockQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DescriptiveBlockQuery = { __typename?: 'query_root', descriptiveBlock?: { __typename?: 'DescriptiveBlock', title?: string | null, description?: { __typename?: 'DescriptiveBlockDescription', json: any } | null, secondDescription?: { __typename?: 'DescriptiveBlockSecondDescription', json: any } | null } | null };

export type GetQaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQaQuery = { __typename?: 'query_root', descriptiveBlockCollection?: { __typename?: 'DescriptiveBlockCollection', items: Array<{ __typename?: 'DescriptiveBlock', title?: string | null, description?: { __typename?: 'DescriptiveBlockDescription', json: any } | null } | null> } | null };

export type FiscoQueryVariables = Exact<{ [key: string]: never; }>;


export type FiscoQuery = { __typename?: 'query_root', fiscoCollection?: { __typename?: 'FiscoCollection', items: Array<{ __typename?: 'Fisco', titolo?: string | null, detrazione?: string | null, descrizione?: { __typename?: 'FiscoDescrizione', json: any } | null } | null> } | null };

export type AddSubNewsletterMutationVariables = Exact<{
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
}>;


export type AddSubNewsletterMutation = { __typename?: 'mutation_root', subscribeNewsletter?: { __typename?: 'SampleOutput', id: string } | null };

export type SearchOffersQueryVariables = Exact<{
  where?: InputMaybe<Models_Bool_Exp>;
}>;


export type SearchOffersQuery = { __typename?: 'query_root', models: Array<{ __typename?: 'models', id: any, prices: Array<{ __typename?: 'prices', monthly_payment: any }> }> };

export type AddLeadMutationVariables = Exact<{
  arg1: LeadInput;
}>;


export type AddLeadMutation = { __typename?: 'mutation_root', addLead?: { __typename?: 'LeadOutput', errors?: Array<string | null> | null } | null };

export type ModelsCardsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  furgone?: InputMaybe<Boolean_Comparison_Exp>;
}>;


export type ModelsCardsQuery = { __typename?: 'query_root', models: Array<{ __typename?: 'models', id: any, prices: Array<{ __typename?: 'prices', monthly_payment: any }> }> };

export type TractionDescQueryVariables = Exact<{
  kind: Scalars['String']['input'];
}>;


export type TractionDescQuery = { __typename?: 'query_root', tractions_by_pk?: { __typename?: 'tractions', description?: string | null } | null };

export type AdminQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminQuery = { __typename?: 'query_root', admin_only: Array<{ __typename?: 'admin_only', id: number }> };

export type SendContactEmailMutationVariables = Exact<{
  vat?: InputMaybe<Scalars['String']['input']>;
  surname: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  content: Scalars['String']['input'];
}>;


export type SendContactEmailMutation = { __typename?: 'mutation_root', sendContactEmail?: { __typename?: 'SampleOutputMail', messageId: string } | null };

export type CopertinaQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CopertinaQuery = { __typename?: 'query_root', copertina?: { __typename?: 'Copertina', copertina?: { __typename?: 'Asset', url?: string | null } | null } | null };

export type ReviewsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReviewsQuery = { __typename?: 'query_root', getRunsLast?: Array<{ __typename?: 'Review', name: string, stars: number, text: string, reviewerPhotoUrl: string } | null> | null };


export const BrandsDocument = gql`
    query Brands {
  brands {
    name
  }
}
    `;

export function useBrandsQuery(options?: Omit<Urql.UseQueryArgs<BrandsQueryVariables>, 'query'>) {
  return Urql.useQuery<BrandsQuery, BrandsQueryVariables>({ query: BrandsDocument, ...options });
};
export const InsertBrandDocument = gql`
    mutation InsertBrand($name: String = "") {
  insert_brands_one(object: {name: $name}) {
    name
  }
}
    `;

export function useInsertBrandMutation() {
  return Urql.useMutation<InsertBrandMutation, InsertBrandMutationVariables>(InsertBrandDocument);
};
export const DeleteBrandDocument = gql`
    mutation DeleteBrand($name: String!) {
  delete_brands_by_pk(name: $name) {
    name
  }
}
    `;

export function useDeleteBrandMutation() {
  return Urql.useMutation<DeleteBrandMutation, DeleteBrandMutationVariables>(DeleteBrandDocument);
};
export const ModelDocument = gql`
    query Model($id: uuid!) {
  models_by_pk(id: $id) {
    brand
    engine
    model_name
    id
    traction_type
    furgone
    imgs
    prices(order_by: {rental_distance: asc, rental_duration: asc}) {
      down_payment
      courtesy_car_price
      id
      monthly_payment
      rental_distance
      rental_duration
      tyres_price
      favorite
    }
  }
}
    `;

export function useModelQuery(options: Omit<Urql.UseQueryArgs<ModelQueryVariables>, 'query'>) {
  return Urql.useQuery<ModelQuery, ModelQueryVariables>({ query: ModelDocument, ...options });
};
export const ModelsDocument = gql`
    query Models {
  models(order_by: {prices_aggregate: {min: {monthly_payment: asc}}}) {
    brand
    engine
    model_name
    id
  }
}
    `;

export function useModelsQuery(options?: Omit<Urql.UseQueryArgs<ModelsQueryVariables>, 'query'>) {
  return Urql.useQuery<ModelsQuery, ModelsQueryVariables>({ query: ModelsDocument, ...options });
};
export const UpdateModelDocument = gql`
    mutation UpdateModel($brand: String, $engine: String, $id: uuid!, $model_name: String, $traction_type: tractions_enum, $imgs: [String!], $furgone: Boolean, $prices: [prices_insert_input!]!) {
  insert_models_one(
    object: {brand: $brand, engine: $engine, id: $id, model_name: $model_name, traction_type: $traction_type, furgone: $furgone, imgs: $imgs, prices: {data: $prices, on_conflict: {constraint: prices_pkey, update_columns: [courtesy_car_price, down_payment, tyres_price, monthly_payment, courtesy_car_price, favorite]}}}
    on_conflict: {constraint: models_pkey, update_columns: [brand, engine, model_name, traction_type, furgone, imgs]}
  ) {
    brand
    engine
    id
    imgs
    model_name
    new_driving_license
    traction_type
  }
}
    `;

export function useUpdateModelMutation() {
  return Urql.useMutation<UpdateModelMutation, UpdateModelMutationVariables>(UpdateModelDocument);
};
export const FinalPricesDocument = gql`
    query FinalPrices($id: uuid!, $duration: Int = 36, $distance: Int = 10000, $courtesy_car: Boolean = false, $tyres: Boolean = false) {
  final_prices(
    where: {model_id: {_eq: $id}, rental_duration: {_eq: $duration}, rental_distance: {_eq: $distance}, courtesy_car: {_eq: $courtesy_car}, tyres: {_eq: $tyres}}
  ) {
    final_monthly_price
    down_payment
  }
  models_by_pk(id: $id) {
    traction_type
    model_name
    imgs
    furgone
    engine
    brand
  }
}
    `;

export function useFinalPricesQuery(options: Omit<Urql.UseQueryArgs<FinalPricesQueryVariables>, 'query'>) {
  return Urql.useQuery<FinalPricesQuery, FinalPricesQueryVariables>({ query: FinalPricesDocument, ...options });
};
export const NewCarDocument = gql`
    mutation NewCar($courtesy_car_price: numeric = 0, $down_payment: numeric = 0, $tyre_price: numeric = 0, $brand: String = "", $model: String) {
  insert_models_one(
    object: {brand: $brand, model_name: $model, traction_type: benzina, engine: "", prices: {data: [{courtesy_car_price: $courtesy_car_price, down_payment: $down_payment, tyres_price: $tyre_price, rental_distance: 10000, rental_duration: 24, monthly_payment: 0}, {courtesy_car_price: $courtesy_car_price, down_payment: $down_payment, tyres_price: $tyre_price, rental_distance: 10000, rental_duration: 36, monthly_payment: 0}, {courtesy_car_price: $courtesy_car_price, down_payment: $down_payment, tyres_price: $tyre_price, rental_distance: 10000, rental_duration: 48, monthly_payment: 0}, {courtesy_car_price: $courtesy_car_price, down_payment: $down_payment, tyres_price: $tyre_price, rental_distance: 10000, rental_duration: 60, monthly_payment: 0}, {courtesy_car_price: $courtesy_car_price, down_payment: $down_payment, tyres_price: $tyre_price, rental_distance: 20000, rental_duration: 24, monthly_payment: 0}, {courtesy_car_price: $courtesy_car_price, down_payment: $down_payment, tyres_price: $tyre_price, rental_distance: 20000, rental_duration: 36, monthly_payment: 0}, {courtesy_car_price: $courtesy_car_price, down_payment: $down_payment, tyres_price: $tyre_price, rental_distance: 20000, rental_duration: 48, monthly_payment: 0}, {courtesy_car_price: $courtesy_car_price, down_payment: $down_payment, tyres_price: $tyre_price, rental_distance: 20000, rental_duration: 60, monthly_payment: 0}, {courtesy_car_price: $courtesy_car_price, down_payment: $down_payment, tyres_price: $tyre_price, rental_distance: 30000, rental_duration: 24, monthly_payment: 0}, {courtesy_car_price: $courtesy_car_price, down_payment: $down_payment, tyres_price: $tyre_price, rental_distance: 30000, rental_duration: 36, monthly_payment: 0}, {courtesy_car_price: $courtesy_car_price, down_payment: $down_payment, tyres_price: $tyre_price, rental_distance: 30000, rental_duration: 48, monthly_payment: 0}, {courtesy_car_price: $courtesy_car_price, down_payment: $down_payment, tyres_price: $tyre_price, rental_distance: 30000, rental_duration: 60, monthly_payment: 0}]}}
  ) {
    new_driving_license
    traction_type
    id
  }
}
    `;

export function useNewCarMutation() {
  return Urql.useMutation<NewCarMutation, NewCarMutationVariables>(NewCarDocument);
};
export const DeleteModelDocument = gql`
    mutation DeleteModel($id: uuid!) {
  delete_models_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteModelMutation() {
  return Urql.useMutation<DeleteModelMutation, DeleteModelMutationVariables>(DeleteModelDocument);
};
export const SearchDocument = gql`
    query Search($brand: String = "", $furgone: Boolean = false) {
  models(
    where: {furgone: {_eq: $furgone}, brand: {_eq: $brand}}
    order_by: {prices_aggregate: {min: {monthly_payment: asc}}}
  ) {
    model_name
    id
  }
  brands(where: {models: {furgone: {_eq: $furgone}}}, order_by: {}) {
    name
  }
}
    `;

export function useSearchQuery(options?: Omit<Urql.UseQueryArgs<SearchQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchQuery, SearchQueryVariables>({ query: SearchDocument, ...options });
};
export const ModelInfoDocument = gql`
    query ModelInfo($id: uuid!) {
  models_by_pk(id: $id) {
    imgs
    brand
    model_name
    furgone
    engine
    traction_type
  }
}
    `;

export function useModelInfoQuery(options: Omit<Urql.UseQueryArgs<ModelInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<ModelInfoQuery, ModelInfoQueryVariables>({ query: ModelInfoDocument, ...options });
};
export const CarForCardDocument = gql`
    query CarForCard($id: uuid = "2b78995d-86eb-4237-93cc-94950c2bf765") {
  models_by_pk(id: $id) {
    brand
    engine
    imgs
    model_name
    id
    traction_type
    prices(
      order_by: [{favorite: desc}, {rental_distance: asc}, {rental_duration: asc}]
      limit: 1
    ) {
      monthly_payment
      down_payment
      rental_distance
      rental_duration
      favorite
    }
  }
}
    `;

export function useCarForCardQuery(options?: Omit<Urql.UseQueryArgs<CarForCardQueryVariables>, 'query'>) {
  return Urql.useQuery<CarForCardQuery, CarForCardQueryVariables>({ query: CarForCardDocument, ...options });
};
export const DescriptiveBlockDocument = gql`
    query DescriptiveBlock($id: String!) {
  descriptiveBlock(id: $id) {
    title
    description {
      json
    }
    secondDescription {
      json
    }
  }
}
    `;

export function useDescriptiveBlockQuery(options: Omit<Urql.UseQueryArgs<DescriptiveBlockQueryVariables>, 'query'>) {
  return Urql.useQuery<DescriptiveBlockQuery, DescriptiveBlockQueryVariables>({ query: DescriptiveBlockDocument, ...options });
};
export const GetQaDocument = gql`
    query GetQa {
  descriptiveBlockCollection(
    where: {contentfulMetadata: {tags: {id_contains_some: "qa"}}}
  ) {
    items {
      title
      description {
        json
      }
    }
  }
}
    `;

export function useGetQaQuery(options?: Omit<Urql.UseQueryArgs<GetQaQueryVariables>, 'query'>) {
  return Urql.useQuery<GetQaQuery, GetQaQueryVariables>({ query: GetQaDocument, ...options });
};
export const FiscoDocument = gql`
    query Fisco {
  fiscoCollection {
    items {
      descrizione {
        json
      }
      titolo
      detrazione
    }
  }
}
    `;

export function useFiscoQuery(options?: Omit<Urql.UseQueryArgs<FiscoQueryVariables>, 'query'>) {
  return Urql.useQuery<FiscoQuery, FiscoQueryVariables>({ query: FiscoDocument, ...options });
};
export const AddSubNewsletterDocument = gql`
    mutation AddSubNewsletter($email: String!, $name: String!, $lastname: String!) {
  subscribeNewsletter(arg1: {email: $email, name: $name, lastname: $lastname}) {
    id
  }
}
    `;

export function useAddSubNewsletterMutation() {
  return Urql.useMutation<AddSubNewsletterMutation, AddSubNewsletterMutationVariables>(AddSubNewsletterDocument);
};
export const SearchOffersDocument = gql`
    query SearchOffers($where: models_bool_exp = {}) {
  models(
    where: $where
    order_by: {prices_aggregate: {min: {monthly_payment: asc}}}
  ) {
    id
    prices(where: {favorite: {_eq: true}}) {
      monthly_payment
    }
  }
}
    `;

export function useSearchOffersQuery(options?: Omit<Urql.UseQueryArgs<SearchOffersQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchOffersQuery, SearchOffersQueryVariables>({ query: SearchOffersDocument, ...options });
};
export const AddLeadDocument = gql`
    mutation AddLead($arg1: LeadInput!) {
  addLead(arg1: $arg1) {
    errors
  }
}
    `;

export function useAddLeadMutation() {
  return Urql.useMutation<AddLeadMutation, AddLeadMutationVariables>(AddLeadDocument);
};
export const ModelsCardsDocument = gql`
    query ModelsCards($limit: Int!, $furgone: Boolean_comparison_exp = {}) {
  models(
    limit: $limit
    where: {furgone: $furgone}
    order_by: {prices_aggregate: {min: {monthly_payment: asc}}}
  ) {
    id
    prices(where: {favorite: {_eq: true}}) {
      monthly_payment
    }
  }
}
    `;

export function useModelsCardsQuery(options: Omit<Urql.UseQueryArgs<ModelsCardsQueryVariables>, 'query'>) {
  return Urql.useQuery<ModelsCardsQuery, ModelsCardsQueryVariables>({ query: ModelsCardsDocument, ...options });
};
export const TractionDescDocument = gql`
    query TractionDesc($kind: String!) {
  tractions_by_pk(kind: $kind) {
    description
  }
}
    `;

export function useTractionDescQuery(options: Omit<Urql.UseQueryArgs<TractionDescQueryVariables>, 'query'>) {
  return Urql.useQuery<TractionDescQuery, TractionDescQueryVariables>({ query: TractionDescDocument, ...options });
};
export const AdminDocument = gql`
    query Admin {
  admin_only {
    id
  }
}
    `;

export function useAdminQuery(options?: Omit<Urql.UseQueryArgs<AdminQueryVariables>, 'query'>) {
  return Urql.useQuery<AdminQuery, AdminQueryVariables>({ query: AdminDocument, ...options });
};
export const SendContactEmailDocument = gql`
    mutation SendContactEmail($vat: String, $surname: String!, $phone: String!, $name: String!, $email: String!, $content: String!) {
  sendContactEmail(
    arg1: {content: $content, email: $email, name: $name, phone: $phone, vat: $vat, surname: $surname}
  ) {
    messageId
  }
}
    `;

export function useSendContactEmailMutation() {
  return Urql.useMutation<SendContactEmailMutation, SendContactEmailMutationVariables>(SendContactEmailDocument);
};
export const CopertinaDocument = gql`
    query Copertina($id: String!) {
  copertina(id: $id) {
    copertina {
      url(transform: {format: WEBP})
    }
  }
}
    `;

export function useCopertinaQuery(options: Omit<Urql.UseQueryArgs<CopertinaQueryVariables>, 'query'>) {
  return Urql.useQuery<CopertinaQuery, CopertinaQueryVariables>({ query: CopertinaDocument, ...options });
};
export const ReviewsDocument = gql`
    query Reviews {
  getRunsLast {
    name
    stars
    text
    reviewerPhotoUrl
  }
}
    `;

export function useReviewsQuery(options?: Omit<Urql.UseQueryArgs<ReviewsQueryVariables>, 'query'>) {
  return Urql.useQuery<ReviewsQuery, ReviewsQueryVariables>({ query: ReviewsDocument, ...options });
};